'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// ==============================
//  THEME SCRIPTS
//  Main file for javascript consolidation. Do not write any javascript in this
//  file! Only include other modules as required.
//  Author: Diff - Foxpod
//  Please review practices documentation before contributing.
// ==============================

// ------------------------------
// MODULES
// ------------------------------
/**
 * UTILITIES LIBRARY
 *
 * @description General global JavaScript utility functions.
 * @namespace theme.utils
 */

(function (theme) {

  /**
   * Class of general JavaScript utilities.
   */
  var Utilities = function () {
    function Utilities() {
      _classCallCheck(this, Utilities);

      // Initialize functions extending objects
      this._handleize();

      // Keep track of all unique numbers generated
      this._rendered_numbers = [];
    }

    /**
     * Initializes the handleize function on the String object.
     * Based on {@link https://github.com/nicbou/stringops stringops} by Nicolas Bouliane.
     *
     * @private
     * @memberof Utilities
     */


    _createClass(Utilities, [{
      key: '_handleize',
      value: function _handleize() {
        // UTF to ASCII map. Removes accents.
        var defaultDiacriticsRemovalap = [{ 'base': 'A', 'letters': 'A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F' }, { 'base': 'AA', 'letters': '\uA732' }, { 'base': 'AE', 'letters': '\xC6\u01FC\u01E2' }, { 'base': 'AO', 'letters': '\uA734' }, { 'base': 'AU', 'letters': '\uA736' }, { 'base': 'AV', 'letters': '\uA738\uA73A' }, { 'base': 'AY', 'letters': '\uA73C' }, { 'base': 'B', 'letters': 'B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181' }, { 'base': 'C', 'letters': 'C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E' }, { 'base': 'D', 'letters': 'D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779' }, { 'base': 'DZ', 'letters': '\u01F1\u01C4' }, { 'base': 'Dz', 'letters': '\u01F2\u01C5' }, { 'base': 'E', 'letters': 'E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E' }, { 'base': 'F', 'letters': 'F\u24BB\uFF26\u1E1E\u0191\uA77B' }, { 'base': 'G', 'letters': 'G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E' }, { 'base': 'H', 'letters': 'H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D' }, { 'base': 'I', 'letters': 'I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197' }, { 'base': 'J', 'letters': 'J\u24BF\uFF2A\u0134\u0248' }, { 'base': 'K', 'letters': 'K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2' }, { 'base': 'L', 'letters': 'L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780' }, { 'base': 'LJ', 'letters': '\u01C7' }, { 'base': 'Lj', 'letters': '\u01C8' }, { 'base': 'M', 'letters': 'M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C' }, { 'base': 'N', 'letters': 'N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4' }, { 'base': 'NJ', 'letters': '\u01CA' }, { 'base': 'Nj', 'letters': '\u01CB' }, { 'base': 'O', 'letters': 'O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C' }, { 'base': 'OI', 'letters': '\u01A2' }, { 'base': 'OO', 'letters': '\uA74E' }, { 'base': 'OU', 'letters': '\u0222' }, { 'base': 'OE', 'letters': '\x8C\u0152' }, { 'base': 'oe', 'letters': '\x9C\u0153' }, { 'base': 'P', 'letters': 'P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754' }, { 'base': 'Q', 'letters': 'Q\u24C6\uFF31\uA756\uA758\u024A' }, { 'base': 'R', 'letters': 'R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782' }, { 'base': 'S', 'letters': 'S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784' }, { 'base': 'T', 'letters': 'T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786' }, { 'base': 'TZ', 'letters': '\uA728' }, { 'base': 'U', 'letters': 'U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244' }, { 'base': 'V', 'letters': 'V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245' }, { 'base': 'VY', 'letters': '\uA760' }, { 'base': 'W', 'letters': 'W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72' }, { 'base': 'X', 'letters': 'X\u24CD\uFF38\u1E8A\u1E8C' }, { 'base': 'Y', 'letters': 'Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE' }, { 'base': 'Z', 'letters': 'Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762' }, { 'base': 'a', 'letters': 'a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250' }, { 'base': 'aa', 'letters': '\uA733' }, { 'base': 'ae', 'letters': '\xE6\u01FD\u01E3' }, { 'base': 'ao', 'letters': '\uA735' }, { 'base': 'au', 'letters': '\uA737' }, { 'base': 'av', 'letters': '\uA739\uA73B' }, { 'base': 'ay', 'letters': '\uA73D' }, { 'base': 'b', 'letters': 'b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253' }, { 'base': 'c', 'letters': 'c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184' }, { 'base': 'd', 'letters': 'd\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A' }, { 'base': 'dz', 'letters': '\u01F3\u01C6' }, { 'base': 'e', 'letters': 'e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD' }, { 'base': 'f', 'letters': 'f\u24D5\uFF46\u1E1F\u0192\uA77C' }, { 'base': 'g', 'letters': 'g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F' }, { 'base': 'h', 'letters': 'h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265' }, { 'base': 'hv', 'letters': '\u0195' }, { 'base': 'i', 'letters': 'i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131' }, { 'base': 'j', 'letters': 'j\u24D9\uFF4A\u0135\u01F0\u0249' }, { 'base': 'k', 'letters': 'k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3' }, { 'base': 'l', 'letters': 'l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747' }, { 'base': 'lj', 'letters': '\u01C9' }, { 'base': 'm', 'letters': 'm\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F' }, { 'base': 'n', 'letters': 'n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5' }, { 'base': 'nj', 'letters': '\u01CC' }, { 'base': 'o', 'letters': 'o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275' }, { 'base': 'oi', 'letters': '\u01A3' }, { 'base': 'ou', 'letters': '\u0223' }, { 'base': 'oo', 'letters': '\uA74F' }, { 'base': 'p', 'letters': 'p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755' }, { 'base': 'q', 'letters': 'q\u24E0\uFF51\u024B\uA757\uA759' }, { 'base': 'r', 'letters': 'r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783' }, { 'base': 's', 'letters': 's\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B' }, { 'base': 't', 'letters': 't\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787' }, { 'base': 'tz', 'letters': '\uA729' }, { 'base': 'u', 'letters': 'u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289' }, { 'base': 'v', 'letters': 'v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C' }, { 'base': 'vy', 'letters': '\uA761' }, { 'base': 'w', 'letters': 'w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73' }, { 'base': 'x', 'letters': 'x\u24E7\uFF58\u1E8B\u1E8D' }, { 'base': 'y', 'letters': 'y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF' }, { 'base': 'z', 'letters': 'z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763' }];

        // Generate the diacritics map to replace accented characters.
        var diacriticsMap = {};
        for (var i = 0; i < defaultDiacriticsRemovalap.length; i++) {
          var letters = defaultDiacriticsRemovalap[i].letters.split("");

          for (var j = 0; j < letters.length; j++) {
            diacriticsMap[letters[j]] = defaultDiacriticsRemovalap[i].base;
          }
        }

        /**
         * Replaces accented characters with their non-accented counterparts.<br>
         * Based on {@link https://github.com/nicbou/stringops stringops} by Nicolas Bouliane.
         *
         * @param {boolean} [remove=false] - Whether to remove unicode characters that are not mapped to a non-accented characters.
         *   This includes all non-ascii characters.
         * @param {string} [replacement=Empty string] - The replacement character(s) to use for invalid characters.
         * @returns {string} String without accents.
         * @memberof Utilities
         * @example
         * // returns 'My accented string$.'
         * 'My áccentéd string$.'.noAccents();
         */
        String.prototype.noAccents = function (remove, replacement) {
          // x00-x7E is the ASCII character range
          var withoutAccents = this.replace(/[^\u0000-\u007E]/g, function (ch) {
            return diacriticsMap[ch] || ch;
          });

          replacement = replacement || '';

          if (remove) {
            withoutAccents = withoutAccents.replace(/[^\u0000-\u007E]/g, replacement);
          }

          return withoutAccents;
        };

        /**
         * Returns a "handleized" version of a string suitable for URLs and file names.<br>
         * Based on {@link https://github.com/nicbou/stringops stringops} by Nicolas Bouliane.
         *
         * @param {string} [seperator=-] - The character to use as a separator.
         * @param {string} [replacement=Empty string] - The replacement character(s) to use for invalid characters.
         * @returns {string} The handleized string.
         * @memberof Utilities
         * @example
         * var myString = 'My áccentéd string$.';
         *
         * // returns 'my-accented-string'
         * myString.handleize();
         *
         * // returns 'my_accented_string##'
         * myString.handleize('_', '#');
         */
        String.prototype.handleize = function (separator, replacement) {
          var slug;
          separator = separator || '-';
          replacement = replacement || '';
          slug = this.noAccents(true, replacement).trim().replace(/[^a-z0-9\s-]/ig, replacement).replace(/\s/ig, separator);

          return slug.toLowerCase();
        };
      }

      /**
       * Currency formating function.
       *
       * @param {(number|string)} price - The price to format.
       * @param {object} options - The options for the currency formatter.
       * @param {boolean} [options.cents=false] - Wether or not the price is currently in cents.
       * @param {string} [options.locale=Shop locale or 'en-CA'] - Override the locale to format to.
       * @param {string} [options.currency=Shop currency or 'CAD'] - Override the currency to output.
       * @param {boolean} [options.no_zeros=false] - To output the price without decimal zeros.
       * @returns {(string|null)} The price formatted based on the locale and currency.
       * @memberof Utilities
       * @example
       * // Returns '$12.56'
       * theme.utils.toMoney(12.56)
       *
       * // Returns '12,56 $'
       * theme.utils.toMoney('12.56', { locale: 'fr-CA', currency: 'CAD' })
       *
       * // Returns '$12.56'
       * theme.utils.toMoney('1256', { cents: true })
       */

    }, {
      key: 'toMoney',
      value: function toMoney(price) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (!price) {
          console.warn('Utilities.toMoney: Invalid price passed.', price);
          return null;
        }

        var price_string = void 0;
        var currency_options = {
          style: 'currency'
        };

        price = new Number(price);

        // Assign defaults if no options are passed.
        options.cents = options.cents || false;
        options.locale = options.locale || (theme.shop ? theme.shop.locale : null) || 'en-CA';
        currency_options.currency = options.currency || (theme.shop ? theme.shop.currency : null) || 'CAD';

        // Convert to dollars if the amount passed is in cents
        if (options.cents) {
          price = price / 100;
        }

        price_string = price.toLocaleString(options.locale, currency_options);

        // Check if there are decimals and no_zeros option is passed
        /*
          !!~ notation will return false instead of -1 for indexOf, and
          true if 0 or greater.
           For more information on how to use the NOT bitwise operator (~),
          read https://www.w3schools.com/js/js_bitwise.asp
        */
        if (options.no_zeros && !!~price_string.indexOf('.00')) {
          price_string = price_string.replace('.00', '');
        }

        return price_string;
      }
    }, {
      key: 'removeProtocol',


      /**
       * Removes the URL protocol.
       *
       * @param {string} path - The URL to strip out the protocol from.
       * @returns {(string|null)} The URL without protocol.
       * @memberof Utilities
       */
      value: function removeProtocol(path) {
        if (!path) {
          console.error('Utilities.removeProtocol: Invalid path passed.', path);
          return null;
        }

        return path.replace(/http(s)?:/, '');
      }

      /**
       * Adds a Shopify size attribute to an image URL.
       *
       * @param {string} src - The image source URL.
       * @param {string} size - The size parameters to fetch, following Shopify's img_url guidelines.
       * @returns {(string|null)} The updated URL.
       * @memberof Utilities
       * @example
       * theme.utils.getSizedImageUrl('cdn.shopify.com/some-image.jpg', '500x300_crop_center');
       */

    }, {
      key: 'getSizedImageUrl',
      value: function getSizedImageUrl(src, size) {
        if (!size) {
          console.error('Utilities.getSizedImageUrl: Invalid size passed.', size);
          return src;
        }

        if (size === 'master') {
          return this.removeProtocol(src);
        }

        var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

        if (match) {
          var prefix = src.split(match[0]);
          var suffix = match[0];

          return this.removeProtocol(prefix[0] + '_' + size + suffix);
        } else {
          console.error('Utilities.getSizedImageUrl: Invalid image URL passed.', src);
          return null;
        }
      }

      /**
       * Created an object from a parameter string.
       *
       * @param {string} object_string - The string to parse to an object.
       * @returns {object} The object created from the string.
       * @memberof Utilities
       * @example
       * // If called on a form that takes a name and email, could return { name: "Joe", email: "joe@diffagency.com" }
       * theme.utils.toObject($form.serialize());
       */

    }, {
      key: 'toObject',
      value: function toObject(object_string) {
        var parameters = {};
        var elements;

        if (!object_string) {
          return {};
        }

        // Split into each element
        elements = object_string.split('&');

        elements.forEach(function (element) {
          var equals_index = element.indexOf('=');
          // check if the query has a value or is only a key
          if (equals_index == -1) {
            // if there's no = then it's only a key, so set the key to the whole element and the value to null
            // Decode to get original characters
            parameters[decodeURIComponent(element)] = null;
          } else {
            // if there's an = then assign up to the = to be the key and everything after to be the value (or null if empty)
            // Decode to get original characters
            var key = decodeURIComponent(element.slice(0, equals_index));
            var value = decodeURIComponent(element.slice(equals_index + 1)) || null;
            parameters[key] = value;
          }
        });

        return parameters;
      }

      /**
       * Extracts the URL parameters into an object.
       *
       * @param {string} [url=window.location.href] - The URL to parse.
       * @returns {object} The query parameters object.
       * @memberof Utilities
       * @example
       * // Returns { name: "Joe", email: "joe@diffagency.com" }
       * theme.utils.getURLParams('https://example.com/?name%3DJoe%26email%3Djoe%40diffagency.com');
       */

    }, {
      key: 'getURLParams',
      value: function getURLParams(url) {
        var url = url || window.location.href;
        // Get the string after the '?' from the URL
        var query_string = url.split(/\?([^\#]+)/)[1];

        if (!query_string) {
          return {};
        }

        return this.toObject(query_string);
      }

      /**
       * Sets URL parameters.
       *
       * @param {object} [params] - The parameters to add to the URL.
       * @param {object} [options] - Method options.
       * @param {boolean} [options.clear=false] - Clear previous parameters.
       * @param {boolean} [options.no_overwrite=false] - Don't overwrite parameters with same key.
       * @param {boolean} [options.push_state=false] - Push a window history state. Defaults to replace state.
       * @memberof Utilities
       * @example
       * // Examples with a current URL of 'example.com/?page=2'
       *
       * // Will set url to 'example.com/?page=3&view=grid'
       * theme.utils.setURLParams({ page: 3, view: 'grid' });
       *
       * // Will set url to 'example.com/?page=2'
       * theme.utils.setURLParams({ page: 3 }, { no_overwrite: true });
       *
       * // Will clear parameters: 'example.com/'
       * theme.utils.setURLParams({}, { clear: true });
       *
       * // Will replace parameters: 'example.com/?view=grid'
       * theme.utils.setURLParams({ view: 'grid' }, { clear: true });
       */

    }, {
      key: 'setURLParams',
      value: function setURLParams(params) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var current_params = this.getURLParams();
        var new_params = options.clear ? {} : current_params;
        var query_array = [];
        var query_string = '';

        // Add new parameters
        Object.keys(params).forEach(function (key) {
          var param_value = params[key];
          new_params[key] = options.no_overwrite ? new_params[key] || param_value : param_value;
        });

        // Convert object to URL string
        Object.keys(new_params).forEach(function (key) {
          query_array.push(encodeURIComponent(key) + '=' + encodeURIComponent(new_params[key]));
        });

        if (query_array.length) {
          query_string = '?' + query_array.join('&');
        }

        if (options.push_state) {
          window.history.pushState({}, null, query_string);
        } else {
          window.history.replaceState({}, null, query_string);
        }
      }

      /**
       * Returns a modified version of the passed object based on the passed parameters.
       *
       * @param {object} object - The object to modify.
       * @param {object} parameters - The parameters to update.
       * @param {object} [options] - Function options.
       * @param {boolean} [options.no_overwrite=false] - Option to not overwrite existing parameters
       * @param {boolean} [options.clear=false] - To empty the object before updating it.
       * @memberof Utilities
       * @example
       * // Returns { name: 'Joe', age: 18, height: 2 }
       * theme.utils.modifyObject(
       *   { name: 'Joe', age: 17 },
       *   { age: 18, height: 2 }
       * );
       *
       * // Returns { name: 'Joe', age: 17, height: 2 }
       * theme.utils.modifyObject(
       *   { name: 'Joe', age: 17 },
       *   { age: 18, height: 2 },
       *   { no_overwrite: true }
       * );
       *
       * // Returns { age: 18, height: 2 }
       * theme.utils.modifyObject(
       *   { name: 'Joe', age: 17 },
       *   { age: 18, height: 2 },
       *   { clear: true }
       * );
       */

    }, {
      key: 'modifyObject',
      value: function modifyObject(object, parameters, options) {
        options = options || {};
        var new_object = options.clear ? {} : object || {};

        if (!object || !parameters || (typeof parameters === 'undefined' ? 'undefined' : _typeof(parameters)) !== 'object') {
          return new_object || {};
        }

        Object.keys(parameters).forEach(function (key) {
          new_object[key] = options.no_overwrite ? new_object[key] || parameters[key] : parameters[key];
        });

        return new_object;
      }

      /**
       * Generates a unique number.
       *
       * @param {number} [length=6] - The length of the unique number
       * @returns Unique number.
       * @memberof Utilities
       * @example
       *
       * // Could generate 66145
       * theme.utils.uniqueNumber(5);
       */

    }, {
      key: 'uniqueNumber',
      value: function uniqueNumber(length) {
        var length = length || 6;
        var id = Math.floor(Math.random() * Math.pow(10, length));

        while (this._rendered_numbers.indexOf(id) !== -1) {
          id = Math.floor(Math.random() * Math.pow(10, length));
        }

        // Keep track of the generated number so that it is never generated again.
        this._rendered_numbers.push(id);

        return id;
      }
    }]);

    return Utilities;
  }();

  // Global export


  theme.utils = new Utilities();
})(window.theme = window.theme || {});

/**
 * CART LIBRARY
 *
 * @description Handles the Shopify cart interactions.
 * @namespace theme.cart
 */

(function (theme, $) {

  /**
   * Class representing the cart.
   */
  var Cart = function () {

    /**
     * Creates an instance of Cart.
     *
     * @param {object} [cart] - A cart object to use. Passing this argument will avoid an AJAX call to the Shopify API.
     * @constructs Cart
     * @memberof Cart
     */
    function Cart(cart) {
      _classCallCheck(this, Cart);

      this.content = cart || {};
      this._queue = $.when();
      this._silent = false;

      // If no cart is passed, fetch it.
      if (!cart) {
        this.fetch();
      }
    }

    // ------------------------------
    //  Getters and Setters
    // ------------------------------

    /**
     * The cart object.<br><br>
     * @example
     * // Get the cart object
     * theme.cart.content
     *
     * @type {object}
     * @fires Cart:set
     * @memberof Cart
     */


    _createClass(Cart, [{
      key: 'fetch',


      // ------------------------------
      //  Methods
      // ------------------------------

      /**
       * Queries the Shopify API to refresh the cart.<br>
       * Calling this function will update the cart object.
       *
       * @param {object} [options] - Properties to change the behaviour of fetch()
       * @param {Boolean} [options.silent=false] - With silent enabled events will not be triggered
       * @fires Cart:fetch
       * @returns {Promise} The AJAX call to Shopify's cart API.
       * @memberof Cart
       * @example
       * theme.cart.fetch();
       */
      value: function fetch() {
        var _this2 = this;

        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$silent = _ref.silent,
            silent = _ref$silent === undefined ? false : _ref$silent;

        this._silent = silent || this._silent;

        this._queue = this._queue.then(function () {
          return $.ajax({
            url: '/cart.js',
            type: 'GET',
            dataType: 'json'
          }).done(function (cart) {
            _this2.content = cart;

            if (!silent) {
              /**
               * The cart has been fetched.
               * The event is attached to the document element.<br><br>
               *
               * @event Cart:fetch
               * @property {object} cart - The cart object.
               * @memberof Cart
               * @example
               * $(document).on('Cart:fetch', function(event, cart) {});
               */
              $(document).trigger('Cart:fetch', _this2.content);
            }
          }).fail(function (resp) {
            console.error('Cart.fetch: Failed getting the cart.', resp);
            console.warn('Clearing the theme.cart._queue object');
            _this2._queue = $.when();
          });
        });

        return this._queue;
      }

      /**
       * Adds an item to cart.
       *
       * @param {(object|number)} item - The item id or item object to add.
       * @param {number} item.id - The id of the variant to add.
       * @param {number} [item.quantity=1] - Quantity to add, defaults to 1.
       * @param {object} [options] - Properties to augment the behaviour of add()
       * @param {Boolean} [options.silent=false] - With silent enabled events will not be triggered
       * @fires Cart:add
       * @returns {Promise} The AJAX call to Shopify's cart API.
       * @memberof Cart
       * @example
       * // Adds 1 of item 1234567 to the cart.
       * theme.cart.add(1234567);
       */

    }, {
      key: 'add',
      value: function add(item) {
        var _this3 = this;

        var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref2$silent = _ref2.silent,
            silent = _ref2$silent === undefined ? false : _ref2$silent;

        this._silent = silent || this._silent;

        if (!item) {
          console.warn('Cart.add: No item was passed.');
          return $.when();
        }

        // Set up the object if only an id is passed.
        if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) != 'object') {
          item = {
            id: item
          };
        }

        // Default the quantity to 1 if none is passed.
        item.quantity = item.quantity || 1;

        this._queue = this._queue.then(function () {
          return $.ajax({
            url: '/cart/add.js',
            data: item,
            type: 'POST',
            dataType: 'json'
          }).done(function (item) {
            // Refresh the cart
            _this3.fetch({ silent: silent });

            if (!silent) {
              /**
               * An item has been added to cart.
               * The event is attached to the document element.<br><br>
               *
               * @event Cart:add
               * @property {object} item - The item added to cart.
               * @memberof Cart
               * @example
               * $(document).on('Cart:add', function(event, item) {});
               */
              $(document).trigger('Cart:add', item);
            }
          }).fail(function (resp) {
            console.error('Cart.add: Failed adding to the cart.', resp);
            console.warn('Clearing the theme.cart._queue object');
            _this3._queue = $.when();
          });
        });

        return this._queue;
      }

      /**
       * Updates an item in the cart.
       *
       * @param {(object|object[]|number|number[])} items - The item id, id array, item object or object array to update.
       * @param {number} items.id - The id of the variant to update.
       * @param {number} [items.quantity=1] - Quantity to add, defaults to 1.
       * @param {object} [options] - Properties to augment the behaviour of update()
       * @param {Boolean} [options.silent=false] - With silent enabled events will not be triggered
       * @fires Cart:update
       * @returns {Promise} The AJAX call to Shopify's cart API.
       * @memberof Cart
       * @example
       * // Updated item 1234567's quantity to 5
       * theme.cart.update({ id: 1234567, quantity: 5 });
       *
       * // Updated item 1234567's quantity to 5 and item 7654321's quantity to 1
       * theme.cart.update([{ id: 1234567, quantity: 5 }, 7654321]);
       */

    }, {
      key: 'update',
      value: function update(items) {
        var _this4 = this;

        var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref3$silent = _ref3.silent,
            silent = _ref3$silent === undefined ? false : _ref3$silent;

        this._silent = silent || this._silent;

        if (!items) {
          console.warn('Cart.update: No item was passed.');
          return $.when();
        }

        var data = {};

        /**
         * Internal function to convert items to the proper format for Shopify's update API call.
         *
         * @param {object} data - The data object to add the key/value pair to.
         * @param {(object|number)} item - The item id or item object to format.
         * @private
         */
        var _addUpdateItem = function _addUpdateItem(item) {
          // Set up the object if only an id is passed.
          if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object') {
            if (!item.id) {
              console.warn('Cart.update: No id was passed with the product object.');
              return $.when();
            }
            data[item.id] = item.quantity || item.quantity === 0 ? item.quantity : 1;
          } else {
            data[item] = 1;
          }
        };

        if (Array.isArray(items)) {
          items.forEach(function (item) {
            _addUpdateItem(item);
          });
        } else {
          _addUpdateItem(items);
        }

        // If data is empty, return empty promise
        if (!Object.keys(data).length) {
          return $.when();
        }

        this._queue = this._queue.then(function () {
          return $.ajax({
            url: '/cart/update.js',
            data: { updates: data },
            type: 'POST',
            dataType: 'json'
          }).done(function (cart) {
            // Refresh the cart
            _this4.content = cart;

            if (!silent) {
              /**
               * An item in the cart has been updated.
               * The event is attached to the document element.<br><br>
               *
               * @event Cart:update
               * @property {object} cart - The cart object.
               * @property {object} item - The item changed.
               * @memberof Cart
               * @example
               * $(document).on('Cart:update', function(event, cart, item) {});
               */
              $(document).trigger('Cart:update', [cart, items]);
            }
          }).fail(function (resp) {
            console.error('Cart.update: Failed updating a cart item.', resp);
            console.warn('Clearing the theme.cart._queue object');
            _this4._queue = $.when();
          });
        });

        return this._queue;
      }

      /**
       * Change an item in the cart.
       *
       * @param {(object|number)} item - The item id or item object to update.
       * @param {number} item.id - The id of the variant to update.
       * @param {number} [item.quantity=1] - Quantity to add, defaults to 1.
       * @param {object} [options] - Properties to augment the behaviour of change()
       * @param {Boolean} [options.silent=false] - With silent enabled events will not be triggered
       * @fires Cart:change
       * @returns {Promise} The AJAX call to Shopify's cart API.
       * @memberof Cart
       * @example
       * // Changes item 1234567's quantity to 2
       * theme.cart.change({ id: 1234567, quantity: 2 });
       */

    }, {
      key: 'change',
      value: function change(item) {
        var _this5 = this;

        var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref4$silent = _ref4.silent,
            silent = _ref4$silent === undefined ? false : _ref4$silent;

        this._silent = silent || this._silent;

        if (!item) {
          console.warn('Cart.change: No item was passed.');
          return $.when();
        }

        // Set up the object if only an id is passed.
        if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) != 'object') {
          item = {
            id: item,
            quantity: 1
          };
        }

        this._queue = this._queue.then(function () {
          return $.ajax({
            url: '/cart/change.js',
            data: item,
            type: 'POST',
            dataType: 'json'
          }).done(function (cart) {
            // Refresh the cart
            _this5.content = cart;

            if (!silent) {
              /**
               * An item in the cart's quantity has been changed.
               * The event is attached to the document element.<br><br>
               *
               * @event Cart:change
               * @property {object} cart - The cart object.
               * @property {object} item - The item changed.
               * @memberof Cart
               * @example
               * $(document).on('Cart:change', function(event, cart, item) {});
               */
              $(document).trigger('Cart:change', [cart, item]);
            }
          }).fail(function (resp) {
            console.error('Cart.change: Failed changing a cart quantity.', resp);
            console.warn('Clearing the theme.cart._queue object');
            _this5._queue = $.when();
          });
        });
        return this._queue;
      }

      /**
       * Updates an item in the cart.
       *
       * @param {(object|object[]|number|number[])} item - The item id, id array, item object or object array to remove.
       * @param {object} [options] - Properties to augment the behaviour of remove()
       * @param {Boolean} [options.silent=false] - With silent enabled events will not be triggered
       * @returns {Promise} The AJAX call to Shopify's cart API.
       * @memberof Cart
       * @example
       * // Removes item 1234567 from the cart
       * theme.cart.remove(1234567);
       */

    }, {
      key: 'remove',
      value: function remove(items) {
        var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref5$silent = _ref5.silent,
            silent = _ref5$silent === undefined ? false : _ref5$silent;

        this._silent = silent || this._silent;

        if (!items) {
          console.warn('Cart.remove: No item was passed.');
          return $.when();
        }

        // Create an array of items with quantity 0 and feed to the update function.
        var remove_items = [];

        if (Array.isArray(items)) {
          items.forEach(function (item) {
            remove_items.push({ id: (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' ? item.id : item, quantity: 0 });
          });
        } else {
          remove_items.push({ id: (typeof items === 'undefined' ? 'undefined' : _typeof(items)) === 'object' ? items.id : items, quantity: 0 });
        }

        return this.update(remove_items, { silent: silent });
      }

      /**
       * Empty the cart.
       *
       * @param {object} [options] - Properties to augment the behaviour of clear()
       * @param {Boolean} [options.silent=false] - With silent enabled events will not be triggered
       * @fires Cart:clear
       * @returns {Promise} The AJAX call to Shopify's cart API.
       * @memberof Cart
       * @example
       * theme.cart.clear();
       */

    }, {
      key: 'clear',
      value: function clear() {
        var _this6 = this;

        var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref6$silent = _ref6.silent,
            silent = _ref6$silent === undefined ? false : _ref6$silent;

        this._silent = silent || this._silent;

        this._queue = this._queue.then(function () {
          return $.ajax({
            url: '/cart/clear.js',
            type: 'POST',
            dataType: 'json'
          }).done(function (cart) {
            // Refresh the cart
            _this6.content = cart;

            if (!silent) {
              /**
               * The cart has been cleared.
               * The event is attached to the document element.<br><br>
               *
               * @event Cart:clear
               * @property {object} cart - The cart object.
               * @memberof Cart
               * @example
               * $(document).on('Cart:clear', function(event, cart) {});
               */
              $(document).trigger('Cart:clear', cart);
            }
          }).fail(function (resp) {
            console.error('Cart.clear: Failed clearing the cart.', resp);
            console.warn('Clearing the theme.cart._queue object');
            _this6._queue = $.when();
          });
        });

        return this._queue;
      }

      /**
       * Updates an attribute in the cart.
       *
       * @param {object} attributes - The attribute(s) to update.
       * @param {object} [options] - The options to pass
       * @param {boolean} [options.no_overwrite=false] - Option to skip setting attributes if they are already set.
       * @param {Boolean} [options.silent=false] - With silent enabled events will not be triggered
       * @fires Cart:attributeUpdate
       * @returns {Promise} The AJAX call to Shopify's cart API.
       * @memberof Cart
       * @example
       * // Update the language attribute to 'fr' and currency to CAD
       * theme.cart.updateAttributes({ language: 'fr', currency: 'CAD' });
       *
       * // Update the language attribute to 'fr' but don't overwrite if already set
       * theme.cart.updateAttributes({ language: 'fr' }, { no_overwrite: true });
       */

    }, {
      key: 'updateAttributes',
      value: function updateAttributes(attributes) {
        var _this7 = this;

        var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref7$no_overwrite = _ref7.no_overwrite,
            no_overwrite = _ref7$no_overwrite === undefined ? false : _ref7$no_overwrite,
            _ref7$silent = _ref7.silent,
            silent = _ref7$silent === undefined ? false : _ref7$silent;

        this._silent = silent || this._silent;

        if (!attributes) {
          console.warn('Cart.updateAttribute: No attributes were passed.');
          return $.when();
        }

        var data = {};

        // If we don't overwrite, only add attributes that are not set in cart
        if (no_overwrite) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = Object.keys(attributes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var key = _step.value;

              if (!this.content.attributes[key]) {
                data[key] = attributes[key];
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        } else {
          data = attributes;
        }

        // If data is empty, return empty promise
        if (!Object.keys(data).length) {
          return $.when();
        }

        this._queue = this._queue.then(function () {
          return $.ajax({
            url: '/cart/update.js',
            data: { attributes: data },
            type: 'POST',
            dataType: 'json'
          }).done(function (cart) {
            // Refresh the cart
            _this7.content = cart;

            if (!silent) {
              /**
               * An item in the cart has been updated.
               * The event is attached to the document element.<br><br>
               *
               * @event Cart:attributeUpdate
               * @property {object} cart - The cart object.
               * @property {object} attributes - The attributes changed.
               * @memberof Cart
               * @example
               * $(document).on('Cart:attributeUpdate', function(event, cart, attributes) {});
               */
              $(document).trigger('Cart:update', [cart, data]);
            }
          }).fail(function (resp) {
            console.error('Cart.attributeUpdate: Failed updating a cart attribute.', resp);
            console.warn('Clearing the theme.cart._queue object');
            _this7._queue = $.when();
          });
        });

        return this._queue;
      }

      /**
       * Clears all or specific attributes in the cart.
       *
       * @param {(string|string[])} [attributes] - The attribute(s) to clear. If none are passed, all will be cleared.
       * @param {object} [options] - Properties to augment the behaviour of clearAttributes()
       * @param {Boolean} [options.silent=false] - With silent enabled events will not be triggered
       * @returns {Promise} The AJAX call to Shopify's cart API.
       * @memberof Cart
       * @example
       * // Clears all cart attributes
       * theme.cart.clearAttributes();
       *
       * // Only clears the language attribute
       * theme.cart.clearAttributes('language');
       *
       * // Clears the language and currency attributes
       * theme.cart.clearAttributes(['language', 'currency']);
       */

    }, {
      key: 'clearAttributes',
      value: function clearAttributes(attributes) {
        var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref8$silent = _ref8.silent,
            silent = _ref8$silent === undefined ? false : _ref8$silent;

        this._silent = silent || this._silent;

        var cleared_attributes = {};

        // If no attributes are passed, use all cart attributes to clear
        var attribute_keys = attributes !== undefined ? [].concat(attributes || []) : Object.keys(theme.cart.content.attributes);

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = attribute_keys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var key = _step2.value;

            cleared_attributes[key] = '';
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        return this.updateAttributes(cleared_attributes, { silent: silent });
      }
    }, {
      key: 'content',
      get: function get() {
        return this._object;
      },
      set: function set(cart) {
        // The Cart class uses a private variable to keep track of the cart content.
        this._object = cart || this._object;

        if (!this._silent) {
          /**
           * The cart has been updated.
           * The event is attached to the document element.<br><br>
           *
           * @event Cart:set
           * @property {object} cart - The cart object.
           * @memberof Cart
           * @example
           * $(document).on('Cart:set', function(event, cart) {});
           */
          $(document).trigger('Cart:set', this.content);
        }

        this._silent = false;
      }
    }]);

    return Cart;
  }();

  // Global export
  // Uses the cart information stored by the global object if available


  theme.cart = new Cart(theme.cart || null);
})(window.theme = window.theme || {}, jQuery);


/**
 * PRODUCTS
 *
 * @description Keeps track of all the products on the page
 * @namespace products
 */

(function (theme, $) {
  /**
   * Class representing the products object.
   */
  var Products = function () {

    /**
     * Creates an instance of Products.
     *
     * @param {object} [products] - An object of product objects with the handle as the key.
     * @constructs Products
     * @memberof Products
     */
    function Products(products) {
      _classCallCheck(this, Products);

      this._list = products || {};
    }

    // ------------------------------
    //  Getters and Setters
    // ------------------------------

    /**
     * The product list object.<br><br>
     * @example
     * // Get the product list
     * theme.products.list
     *
     * @type {object}
     * @memberof Products
     */


    _createClass(Products, [{
      key: 'update',


      // ------------------------------
      //  Methods
      // ------------------------------

      /**
       * Update the product list.
       * If the product doesn't exist, it will be added.
       * If the product exists, it will be updated. Parameters would be updated, not replaced.
       *
       * @param {(object|object[])} products - Product, object of products or array of products to add to the list.
       * @fires Products:add
       * @fires Products:change
       * @memberof Products
       * @example
       * // Examples use the following list:
       * // {
       * //   product-a: { handle: 'product-a', title: 'Product A' },
       * //   product-b: { handle: 'product-b', title: 'Product B' }
       * // }
       *
       * // Add 1 product
       * theme.products.update({ handle: 'product-c', title: 'Product C' });
       *
       * // Add product array
       * theme.products.update([
       *   { handle: 'product-c', title: 'Product C' },
       *   { handle: 'product-d', title: 'Product D' }
       * ]);
       *
       * // Add multiple product object
       * theme.products.update({
       *   product-c: { handle: 'product-c', title: 'Product C' },
       *   product-d: { handle: 'product-d', title: 'Product D' }
       * });
       *
       * // If the product exists, it will update the passed parameters
       * // Will result in product a having the following structure:
       * // { handle: 'product-a', title: 'Product A', price: 1200 }
       * theme.products.update({ handle: 'product-a', price: 1200 });
       */
      value: function update(products) {
        var _this8 = this;

        if (!products || (typeof products === 'undefined' ? 'undefined' : _typeof(products)) !== 'object') {
          return false;
        }

        // Convert to array if single product is passed
        if (products.handle) {
          products = [products];
        } else if (!Array.isArray(products)) {
          // Convert object of products into array of products
          products = Object.keys(products).map(function (key) {
            return products[key];
          }).filter(function (product) {
            return product.handle;
          });
        }

        products.forEach(function (product) {
          if (product.handle) {
            // If the product doesn't exists, add it, otherwise update it
            if (!_this8._list[product.handle]) {
              _this8._list[product.handle] = product;

              /**
               * Products have been added to the global list.
               * The event is attached to the document element.<br><br>
               *
               * @event Products:add
               * @property {object} product_added - The added product
               * @memberof Products
               * @example
               * $(document).on('Products:add', function(event, product_added) {});
               */
              $(document).trigger('Products:add', product);
            } else {
              var product_updated = theme.utils.modifyObject(_this8._list[product.handle], product);
              _this8._list[product.handle] = product_updated;

              /**
               * Product has been updated on the global list.
               * The event is attached to the document element.<br><br>
               *
               * @event Products:update
               * @property {object} product_updated - The updated product
               * @memberof Products
               * @example
               * $(document).on('Products:update', function(event, product) {});
               */
              $(document).trigger('Products:update', product_updated);
            }
          }
        });
      }
    }, {
      key: 'list',
      get: function get() {
        return this._list;
      },
      set: function set(cart) {
        // Don't allow the list to be overwritten
        return false;
      }
    }]);

    return Products;
  }();

  // Global export and initialization
  // Uses the products stored by the global object if available


  theme.products = new Products(theme.products && theme.products.list ? theme.products.list : {});
})(window.theme = window.theme || {}, jQuery);
(function (theme, $) {
  /**
   * Modal LIBRARY
   *
   * @description Handles the Shopify modal interactions.
   * @namespace Modal
   * @example To create anew modal you do the following --> var new_modal = new theme.Modal('modal-id'); new_modal.show();
   */
  var Modal = function () {
    /**
     * Creates an instance of Modal
     *
     * @param {string} id - The id of the modal
     * @param {object} params - Parameters to modify the classe's behaviour
     * @constructs Modal
     * @memberof Modal
     */
    function Modal(id, params) {
      _classCallCheck(this, Modal);

      if (!id) {
        return false;
      }

      this.modal = document.getElementById(id);

      this.defaults = {
        backdrop_fade_in_delay: 500,
        backdrop_fade_out_delay: 1000,
        backdrop_opacity: 0.68,
        backdrop_selector: '.modal__backdrop',
        close_event: 'click',
        close_selector: '[data-modal-close]',
        close_on_escape: true,
        close_on_overlay_click: true,
        trap_tab_key: true,
        focus_on_open: true,
        container_fade_in_delay: 500,
        container_fade_out_delay: 500,
        container_selector: '.modal__container',
        modal_state_open: "modal--open"
      };

      this.focusable_elements_string = 'a[href], area[href], input:not([disabled]):not([type=hidden]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable]';
      this.focusable_elements = [].concat(_toConsumableArray(this.modal.querySelectorAll(this.focusable_elements_string)));

      this.first_focusable_element = this.focusable_elements[0];
      this.lastFocusableElement = this.focusable_elements[this.focusable_elements.length - 1];
      this.options = $.extend({}, this.defaults, params || {});

      this.backdrop = this.modal.querySelector(this.options.backdrop_selector);
      this.container = this.modal.querySelector(this.options.container_selector);
      this.closers = this.modal.querySelectorAll(this.options.close_selector);

      if (!this.modal.getAttribute('role') && !this.modal.getAttribute('aria-role')) {
        this.modal.setAttribute('role', 'dialog');
        this.modal.setAttribute('aria-role', 'dialog');
      }

      // Add aria-modal attribute if not present
      if (!this.modal.getAttribute('aria-modal')) {
        this.modal.setAttribute('aria-modal', true);
      }

      this.bindListeners();
    }

    _createClass(Modal, [{
      key: 'show',
      value: function show() {
        $(this.modal).addClass(this.options.modal_state_open);
        $(this.backdrop).fadeTo(this.options.backdrop_fade_in_delay, this.options.backdrop_opacity);
        $(this.container).fadeIn(this.options.container_fade_in_delay);
        $(this.modal).trigger('Modal::show');

        if (this.options.focus_on_open) {
          // stores reference to element that was focused before modal opened, so we can return to it when modal closes
          this.focused_element_before_modal = document.activeElement;
          this.first_focusable_element.focus();
        }
        document.body.classList.add('noscroll');
        this.$allTabable = $('a[href], area[href], input:not([disabled]):not([type=hidden]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex], [contenteditable]');
        this.$allTabable.each(function () {
          // check that the element in in the modal & that he data attribute doesnt already exist so that it doesn't get overwritten 
          if (!$(this).data('tabindex') && !$(this).closest('.modal .modal__container').length) {
            // if element doesnt have a tabindex it will be listed as undefined, so we set that to 0
            var tabindex = $(this).attr('tabindex') == undefined || $(this).attr('tabindex') == 'undefined' ? '0' : $(this).attr('tabindex');
            $(this).attr('data-tabindex', tabindex);
            $(this).attr('tabindex', '-1');
          };
        }); 
      }
    }, {
      key: 'hide',
      value: function hide() {
        /*$(this.modal).removeClass(this.options.modal_state_open);
        $(this.backdrop).fadeOut(this.options.backdrop_fade_out_delay);
        $(this.container).fadeOut(this.options.container_fade_out_delay);
        $(this.modal).trigger('Modal::hide');

        if (this.options.focus_on_open) {
          //returns focus to element that was focused before modal opened
          this.focused_element_before_modal.focus();
        }
        var cart = document.querySelector('.js-flyout.js-cart-flyout');
        if (!cart.classList.contains('flyout-active-right')) {
          document.body.classList.remove('noscroll');
        }
        // give them back their tabindexes
        this.$allTabable.each(function () {
          var tabindex = $(this).data('tabindex');
          $(this).attr('tabindex', tabindex);
        });*/
      }
    }, {
      key: 'handleTabKey',
      value: function handleTabKey(e) {
        // if it's shift + tab and they're on the first focusable element it loops around to the last focusable element
        // otherwise on the last focusable element and tab is pressed it loops around to first focusable element
        if (e.shiftKey) {
          if (this.first_focusable_element === document.activeElement) {
            e.preventDefault();
            this.last_focusable_element.focus();
          }
        } else {
          if (this.last_focusable_element === document.activeElement) {
            e.preventDefault();
            this.first_focusable_element.focus();
          }
        }
      }
    }, {
      key: 'bindListeners',
      value: function bindListeners() {
        var _this9 = this;

        for (var i = 0; i < this.closers.length; i++) {
          $(this.closers[i]).on(this.options.close_event, function () {
            _this9.hide();
          });
        }

        // Handle the ESC closing and Tab trapping of the modal
        this.modal.addEventListener('keydown', function (e) {
          if (_this9.options.close_on_escape && _this9.options.modal_state_open && e.keyCode === 27) {
            _this9.hide();
          }
          if (_this9.options.trap_tab_key && _this9.options.modal_state_open && e.keyCode === 9) {
            _this9.handleTabKey(e);
          }
        });
      }
    }]);

    return Modal;
  }();

  theme.Modal = Modal;
})(window.theme = window.theme || {}, jQuery);
/**
 * VARIANT SELECTOR LIBRARY
 *
 * @description Handles selection of variants, determines state of a selection, and broadcasts related events
 * @namespace variantSelector
 */

(function (theme, $) {
  /**
   * The VariantSelector manages attaching events and triggers between
   * variant selector elements and the variant selector engine.
   * The state of each Option is stored as the value of that option's input element (referred to as an "option_selector").
   * The combination of all "option_selector" values is referred to as the "selection".
   * The state of the currently selected Variant is stored as an input element in the product form (referred to as "id_field").
   * When the value of an "option_selector" changes, this library determines if the current "selection" is Complete, Illegal, or Incomplete. If it's Complete, it changes the "id_field".
   * Settings can be specified in the constructor or a 'data-variant-selector' attribute
   * on the container.
   * @class
   * @example
   * //<div class="js-my-variant-selector" data-variant-selector="{ update_atc: false }">
   * //    <!-- ... -->
   * //</div>
   * let variant_selector = new VariantSelector($('.js-my-variant-selector'), { selectors: { atc_button: '.js-my-atc' }});
   */
  var VariantSelector = function () {
    /**
     *
     * @param {jQuery} $container - The container encompassing all variant selector DOM elements
     * @param {Object} [settings] - Configurable Variant Selector settings
     * @param {Object} [settings.selectors] - Selectors for selecting DOM elements
     * @param {string} [settings.selectors.option_selector='.js-option-selector'] - Input elements for selecting a variant option's value.
     * The option's name should be in the name attribute and its value should be in the value attribute of the input. Note that these elements can be outside of the form, as option values are not used when adding to cart- only the Variant ID.
     * @param {string} [settings.selectors.id_field='[name="id"]'] - Selector for form elements specifying the selected variant by id.
     * This is usually some sort of input element with name="id", and its value (a Variant ID) will be used when adding to cart.
     * @param {string} [settings.selectors.$atc_button='[type="submit"]'] - Selector for the Add to Cart button.
     * This is usually the submit button for your form. It will get enabled/disabled based on the selected variant and whether it is in stock.
     * @param {Boolean} [settings.update_atc=true] - Whether the atc button show be enabled/disabled
     * @param {Boolean} [settings.update_id_field=true] - Whether the id field should be updated
     * @param {boolean} [settings.reset_selection=false] - Whether to reset less significant options when a more significant one is selected
     * @constructs VariantSelector
     *
     */
    function VariantSelector($container, settings) {
      var _this10 = this;

      _classCallCheck(this, VariantSelector);

      var defaults = {
        selectors: {
          option_selector: '.js-option-selector',
          id_field: '[name="id"]',
          atc_button: '[type="submit"]'
        },
        update_atc: true,
        update_id_field: true,
        reset_selection: false
      };

      this.$container = $container;

      var data_options = this.$container.data('variant-selector');
      this.options = $.extend(true, {}, defaults, data_options, settings);

      this.elements = {
        $id_field: $(this.options.selectors.id_field, this.$container),
        $atc_button: $(this.options.selectors.atc_button, this.$container),
        $option_selectors: $(this.options.selectors.option_selector, this.$container)
      };

      // Determine whether the id field is a set of radio buttons
      // and should be checked
      var id_field_type = this.elements.$id_field.attr('type');
      this.check_id_field = id_field_type && id_field_type.toLowerCase() === 'radio';

      if (this.options.update_atc) {
        this.$container.on('VariantSelector:selectionComplete', function (event, variant) {
          if (_this10.options.update_id_field) {
            _this10.setIdField(variant.id);
          }

          if (variant.available && (variant.inventory_policy == "continue" || variant.inventory_quantity > 0)) {
            _this10.enableAtc();
          } else {
            _this10.disableAtc();
          }

          _this10.setMultilingualProperties(variant);
        });
        this.$container.on('VariantSelector:selectionIllegal', function () {
          return _this10.disableAtc();
        });
        this.$container.on('VariantSelector:selectionIncomplete', function () {
          return _this10.disableAtc();
        });
      } else if (this.options.update_id_field) {
        this.$container.on('VariantSelector:selectionComplete', function (event, variant) {
          _this10.setIdField(variant.id);
          _this10.setMultilingualProperties(variant);
        });
      }

      if (this.elements.$option_selectors.length > 0) {
        // Create the variant selector object with associated fields and selected values
        this.variant_selector = new VariantSelectorEngine({
          product_handle: this.$container.data('product-handle'),
          selected_values: this.elements.$option_selectors.get().reduce(function (acc, cur) {
            if (cur.checked) {
              acc[cur.getAttribute('name')] = cur.value;
            }
            return acc;
          }, {}),
          $event_root: this.$container,
          reset_selection: this.options.reset_selection
        });

        // Set the PDP's (Product Display Page's) radio buttons or select dropdowns as triggers for the variant selector
        this.elements.$option_selectors.each(function (index, element) {
          if (element.tagName === 'SELECT') {
            _this10.variant_selector.addTrigger($(element), 'change', element.getAttribute('name'), function () {
              return element.value;
            });
          } else {
            _this10.variant_selector.addTrigger($(element), 'change', element.getAttribute('name'), element.value);
          }
        });
      } else {
        // Create the variant selector object with associated fields and selected values
        this.variant_selector = new VariantSelectorEngine({
          product_handle: this.$container.data('product-handle'),
          $event_root: this.$container,
          reset_selection: this.options.reset_selection
        });

        // When we've selected a variant
        this.elements.$id_field.on('change', function (event) {
          return _this10.variant_selector.setVariant(parseInt(event.target.value));
        });

        // Set the initial selection
        if (!this.check_id_field) {
          this.variant_selector.setVariant(parseInt(this.elements.$id_field.val()));
        } else {
          var $selected_radio_button = this.elements.$id_field.filter(':checked');

          if ($selected_radio_button.length > 0) {
            this.variant_selector.setVariant(parseInt($selected_radio_button.val()));
          }
        }
      }
    }

    /**
     * Enable the Add to Cart button
     * @memberof VariantSelector
     */


    _createClass(VariantSelector, [{
      key: 'enableAtc',
      value: function enableAtc() {
        this.elements.$atc_button.prop('disabled', false);
      }

      /**
       * Disable the Add to Cart button
       * @memberof VariantSelector
       */

    }, {
      key: 'disableAtc',
      value: function disableAtc() {
        this.elements.$atc_button.prop('disabled', true);
      }

      /**
       * Update the form's id field with the currently selected variant
       * @param {number} variantId - The selected variant
       * @memberof VariantSelector
       */

    }, {
      key: 'setIdField',
      value: function setIdField(variantId) {
        if (this.check_id_field) {
          this.elements.$id_field.filter(function (index, element) {
            return parseInt(element.value) === variantId;
          }).prop("checked", true);
        } else {
          this.elements.$id_field.val(variantId);
        }
      }

      /**
       * Update the form's multilingual fields with the currently selected variant
       * @param {object} variant - The selected variant
       * @memberof VariantSelector
       */

    }, {
      key: 'setMultilingualProperties',
      value: function setMultilingualProperties(variant) {
        var _this11 = this;

        theme.multilingual.settings.locales_supported.forEach(function (locale) {
          _this11.$container.find('[name="properties[_' + locale + '__variant_title]"]').val(variant.multilingual[locale].title);
        });
      }
    }]);

    return VariantSelector;
  }();

  /**
   * Variant selector class holds the product and its
   * variants, determines state of the variant selector based
   * on selected options
   * @example
   * // Example construction configurations
   * let settings = {};
   * settings.product_handle = 'green-top';
   * settings.selected_values = {
   *     'color': $('.product__form-swatches:checked')
   * };
   *
   * let variant_selector = new VariantSelectorEngine(settings);
   */


  var VariantSelectorEngine = function () {

    /**
     * @constructs VariantSelectorEngine
     * @memberof VariantSelectorEngine
     * @param {Object} settings - Variant Selector settings
     * @param {string} settings.product_handle - Product handle for this variant selector
     * @param {Object.<string, string>} [settings.selected_values] - A map of option names to values {"option_name": "value", ... } to indicates preselected values
     * @param {jQuery} [settings.$event_root=$()] - Root element for triggering events
     * @param {boolean} [settings.reset_selection=false] - Whether to reset less significant options when a more significant one is selected
     */
    function VariantSelectorEngine(settings) {
      var _this12 = this;

      _classCallCheck(this, VariantSelectorEngine);

      this.settings = settings;
      this.product = theme.products.list[settings.product_handle];
      this.$event_root = settings.$event_root || $();
      this.reset_selection = settings.reset_selection || false;
      this.option_order = [];

      // Create a map of option_names to option values
      this.variant_options = this.product.options_with_values.reduce(function (acc, cur) {
        acc[cur.name] = new VariantOption(cur, _this12.$event_root);
        return acc;
      }, {});

      if (this.reset_selection) {
        this.option_order = this.product.options_with_values.map(function (option) {
          return option.name;
        });
      }

      if (this.settings.selected_values) {
        // Pre-select default options
        Object.keys(this.settings.selected_values).forEach(function (option) {
          return _this12.variant_options[option].selected = _this12.settings.selected_values[option];
        });

        this.updateVariantSelector();
      }
    }

    /**
     * A getvalue function can be passed to dynamically determine the value of a trigger
     * @callback getOptionTriggerValue
     * @param {jQuery} $element - The DOM element triggering the option change
     * @returns {string} The selected value
     */

    /**
     * Add a trigger to select a specific value for an option
     * @param {jQuery} $element - DOM element triggering an event
     * @param {string} event - Event name
     * @param {string} name - Option name being updated
     * @param {(string|getOptionTriggerValue)} value - Can be a string or a callback function to get the value
     * @memberOf VariantSelectorEngine
     *
     * @example
     * // Some examples for different types of elements that could be
     * // used to select options
     *
     * // A simple button that sets a single value
     * variant_selector.addTrigger($('product__button-green'), 'click', 'color', 'green');
     *
     * // A set of radio buttons for a single option
     * // (for example a set of colour swatches)
     * $('product__color-swatch').each((index, element) =>
     *     variant_selector.addTrigger($(element), 'change', 'color', element.value)
     * );
     *
     * // An example where all selectors are selected and the option is determined procedurally
     * $('product__selector').each((index, element) =>
     *     variant_selector.addTrigger($(element), 'change', element.getAttribute('name'), element.value)
     * );
     *
     * // An example where instead of setting the value, a function to retrieve the value is provided.
     * // Useful for cases like dropdown boxes.
     * const $color_dropdown = $('product__color-dropdown');
     * variant_selector.addTrigger($color_dropdown, 'change', 'color', () => $color_dropdown.val());
     */


    _createClass(VariantSelectorEngine, [{
      key: 'addTrigger',
      value: function addTrigger($element, event, name, value) {
        var _this13 = this;

        // Attach the event
        $element.on(event, function () {
          var select_value = void 0;

          // Determine if we have the value or must call the function
          if (typeof value === 'function') {
            select_value = value($element);
          } else {
            select_value = value;
          }

          _this13.updateSelection(name, select_value);
        });
      }

      /**
       * Update the variant selector with a new value for an option and
       * trigger events
       *
       * @param {string} option_name - The name of the option being updated
       * @param {string} option_value - The new value of the updated option
       * @fires VariantSelectorEngine#VariantSelector:selectionUpdated
       */

    }, {
      key: 'updateSelection',
      value: function updateSelection(option_name, option_value) {
        var _this14 = this;

        this.variant_options[option_name].selected = option_value;

        if (this.reset_selection) {
          var start_resetting = false;
          this.option_order.forEach(function (option) {
            if (option === option_name) {
              start_resetting = true;
            } else if (start_resetting) {
              _this14.variant_options[option].selected = undefined;
            }
          });
        }

        this.updateVariantSelector();
      }

      /**
       * Directly set the variant selected by ID
       *
       * @param {number} variant_id - Variant Id to select
       * @fires VariantSelectorEngine#VariantSelector:selectionUpdated
       * @example
       * // Example setting variants based on events from radio buttons
       * $variant_radios.on('change', event =>
       *     variant_selector.setVariant(parseInt(event.target.value))
       * );
       */

    }, {
      key: 'setVariant',
      value: function setVariant(variant_id) {
        var _this15 = this;

        var variant = this.product.variants.find(function (variant) {
          return variant.id === variant_id;
        });

        this.product.options_with_values.forEach(function (value, index) {
          return _this15.variant_options[value.name].selected = variant.options[index];
        });

        this.updateVariantSelector();
      }

      /**
       * Find the possible variants meeting the selected options and
       * call methods to update the variant selector appropriately
       * @fires VariantSelectorEngine#VariantSelector:selectionUpdated
       */

    }, {
      key: 'updateVariantSelector',
      value: function updateVariantSelector() {
        var _this16 = this;
        var newMultipleVariantsStr = "";
    
        var $cart = $('.cart');
        var CLASSES = {
          container: '.js-cart-form-container'
        };

        var cart_lock = false;

        function lockCart() {
          cart_lock = true;
          $cart.addClass('is-loading');
          $('.js-atc-button').prop('disabled', true);
        }

        function unlockCart() {
          cart_lock = false;
          $cart.removeClass('is-loading');
          $('.js-atc-button').prop('disabled', false);
        }
        // Find the variant that matches the currently selected set of options
        var possible_variants = this._possible_variants = this.product.variants.filter(function (variant) {
          return Object.keys(_this16.variant_options).every(function (currentValue) {
            return (
              // If there is no value selected for an option, allow all variants with the option
              _this16.variant_options[currentValue].selected === undefined || variant[_this16.variant_options[currentValue].option_index] === _this16.variant_options[currentValue].selected
            );
          });
        });

        // Check that all options have something selected
        var selection_complete = Object.keys(this.variant_options).every(function (option) {
          return !!_this16.variant_options[option].selected;
        });

        this.filtered_options = {};

        // Loop through all the options
        Object.keys(this.variant_options).forEach(function (option_name) {
          // Set the available variants for that option
          _this16.filtered_options[option_name] = _this16.product.variants.filter(function (variant) {
            return variant.available && Object.keys(_this16.variant_options).filter(function (option_key) {
              return option_key != option_name;
            }).reduce(function (acc, option_key) {
              var inner_option = _this16.variant_options[option_key];

              return acc && (!inner_option.selected || variant[inner_option.option_index] == inner_option.selected);
            }, true);
          });
        });

        // Notify all listeners of the selection update
        /**
         * Selection update, a trigger attempted to
         * change the selected options
         *
         * @event VariantSelectorEngine#VariantSelector:selectionUpdated
         * @property {Object[]} possible_variants - A list of possibly selected variants. This could be 0, 1, or many variants.
         * @property {boolean} selection_complete - Whether all options were selected
         *
         * See the selection_complete, selection_illegal, and selection_incomplete events for more information on these cases.
         * @example
         * // Do something when the variant selector is updated. See VariantSelector:selectionUpdated
         * // for why the returned variants can be a variable number (not just 1).
         * $variantSelector.on('VariantSelector:selectionUpdated', (event, variants, complete) =>
         *     console.log('Possible number of variants that can be selected:', variants.length)
         * );
         */
        this.$event_root.trigger('VariantSelector:selectionUpdated', [possible_variants, selection_complete]);
        console.log(4,possible_variants);
        var optionMsg, optionMsgElem, appendMsg, pOption2;
        var stockMsg = $(".product__stock-message").html();
        var formMsgClass = $(".form--product__messages");
        var optionLimit = ".limit", optionVar = ".variant";

        formMsgClass.html("");

        for(var i=0; i < possible_variants.length; i++)  {
          pOption2 = possible_variants[i].option2;
          pOption2 = pOption2.replace("/", "-"); // avoid special charactes on data attr

          newMultipleVariantsStr += "<div class='form--product__variants-container "
          if(!possible_variants[i].available) {
          newMultipleVariantsStr += " is-unavailable "
          }
          newMultipleVariantsStr += "'>";
          newMultipleVariantsStr += "<span>" + possible_variants[i].option2 + "</span>"
          newMultipleVariantsStr += "<input type='number' data-variant-id='"+ possible_variants[i].id + "'"
          newMultipleVariantsStr += "		data-length='" + possible_variants[i].inventory_quantity + "'"
          newMultipleVariantsStr += "		max-length='" + possible_variants[i].inventory_quantity + "'"
          newMultipleVariantsStr += "		data-product-handle='" + possible_variants[i].product_handle + "'"
          newMultipleVariantsStr += "		data-option1='" + possible_variants[i].option1 + "' data-option2='" + pOption2 + "'"
          if(!possible_variants[i].available) {
          	newMultipleVariantsStr += "		disabled"
          }
          newMultipleVariantsStr += " 		class='form--product__variants-qty'>"
          newMultipleVariantsStr += "</div>"; 
          
          optionMsgElem = "option__" + possible_variants[i].product_handle + "--" + pOption2;
          optionMsg = "option__message " + optionMsgElem + " ";
          
          appendMsg = "<div class='" + optionMsg + "'>" + stockMsg + "</div>";
          
          formMsgClass.append(appendMsg);
          
          $(".option__message." + optionMsgElem + " " + optionLimit).html(possible_variants[i].inventory_quantity);
          $(".option__message." + optionMsgElem + " " + optionVar).html(pOption2);
          //console.log(5, ".option__message." + optionMsgElem + " " + optionLimit);
        }

        var cart = CartJS.cart.items;
        
        function disableState() {
          $(".addToCartAjax").prop("disabled", true);
          $(".addToCartAjax .js-label-add_to_cart").hide();
          $(".addToCartAjax .js-label-atc_disabled").show();
          $(".wishlist-button").prop("disabled", true);
        }
        
        function enableState() {
          $(".addToCartAjax").prop("disabled", false);
          $(".addToCartAjax .js-label-add_to_cart").show();
          $(".addToCartAjax .js-label-atc_disabled").hide();
          $(".wishlist-button").prop("disabled", false);
        }

        // update variant quantity fields
        $(".form--product__multiple-variants").html(newMultipleVariantsStr);

        var qtyChange, qtyMax, qtyChangeVal, variantQtyId, option1, index, variantQtyArr = [],
            cartProductHandle, cartVariantID, cartQty, cartProperties,
            selProductHandle, selOption2, msgClass, currMsgClass;

        // once the swatch changes, disable to add to cart and wishlist button
        disableState();
        
        // watch if size option quantity value changes
        $(".form--product__variants-qty").on("input", function() {
          qtyChange = $(this);
          qtyMax = qtyChange.data('length');
          selProductHandle = qtyChange.data("product-handle");
          selOption2 = qtyChange.data("option2");
          msgClass = ".option__message.option__" + selProductHandle + "--" + selOption2;

          qtyChangeVal = qtyChange.val();

          $(".form--product__variants-qty").each(function() {
            variantQtyId = $(this).data("variant-id");
            index = variantQtyArr.indexOf(variantQtyId);
            currMsgClass = ".option__message.option__" + $(this).data("product-handle") + "--" + $(this).data("option2");

            if($(this).val() > 0 && $(this).val() != "" && $(this).val() <= $(this).data("length")) {
              if($(this).val() <= $(this).data("length")) {
                $(currMsgClass).removeClass("is-active");

                if($(".option__message").hasClass("is-active")) {
                  disableState();
                } else {
                  if(index <= -1) {
                    variantQtyArr.push(variantQtyId);
                  }
                  // enable add to cart if there's value on at least one of quantity box
                  enableState();
                }
              }
            } else {
              console.log($(this).val() > $(this).data("length"));
              if($(this).val() > $(this).data("length")) {
                $(currMsgClass).addClass("is-active");
                disableState();
              } else {
                $(currMsgClass).removeClass("is-active");
                if($(".option__message").hasClass("is-active")) {
                  disableState();
                }
              }
              if(index > -1) {
                variantQtyArr.splice(index, 1);
              }
            }
          });
        });
        
        $(".addToCartAjax").unbind().click(function() {
          // update submit button's product handle
          var productHandle = possible_variants[0].product_handle;
          var lineProperties = {}, mappedCart = [], cartSaved = false;
          var newCartObjectTemp, newCartQty, newCartQtyVal, newCartvariantID, newCartProperties, edit_item_modal;
		  var modal_id = $(this).data('modal-target');
      	  //edit_item_modal = new theme.Modal(modal_id);
          
          // disable buttons
          disableState();
          // add selected color
          option1 = possible_variants[0].option1;

          // get product properties
          $(".line-properties").each(function() {
            var lineProp = $(this);
            var linePropName = lineProp.data("property-name");
            var linePropNameVal = lineProp.val();
            lineProperties[linePropName] = linePropNameVal;
          });
          
          lineProperties._color = option1;
          cart = CartJS.cart.items;

          if(cart.length > 0) {
            // return cart items except item = selected item
            mappedCart = cart.reverse().filter(function (cartjs) {
              return cartjs.handle != productHandle;
            }).map(cartjs => ({
              id: cartjs.variant_id,
              quantity: cartjs.quantity,
              properties: cartjs.properties
            }));
          }

          // loop through qty field and get data: variant id
          $($(".form--product__variants-qty").get().reverse()).each(function() {
            newCartObjectTemp = {};
            newCartQty = $(this);
            newCartvariantID = newCartQty.data("variant-id");
            newCartQtyVal = newCartQty.val();

            if(typeof newCartQty !== 'undefined' && newCartQtyVal > 0) {
              newCartObjectTemp = {
                id: newCartvariantID,
                quantity: parseInt(newCartQtyVal),
                properties: lineProperties
              }

              mappedCart.push(newCartObjectTemp);
            }
          });

          // add items to cart
          CartJS.clear();

          CartJS.addItems(mappedCart, {
            "success": function(data, textStatus, jqXHR) {
              enableState();

              /* setTimeout(function () {
              	edit_item_modal.hide();
              },900); */

              $("#edit-item-modal").removeClass("modal--open");
              $("#edit-item-modal .product__images").removeClass("is-active");
              $("#edit-item-modal .modal__backdrop").fadeTo(500, 0.68);
              $("#edit-item-modal .modal__container").fadeIn(500);
              $("#edit-item-modal").trigger('Modal::hide');
              
              var cart = document.querySelector('.js-flyout.js-cart-flyout');
              if (!cart.classList.contains('flyout-active-right')) {
                document.body.classList.remove('noscroll');
              }
              var allTable = $('a[href], area[href], input:not([disabled]):not([type=hidden]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex], [contenteditable]');
              // give them back their tabindexes
              allTable.each(function () {
                var tabindex = $(this).data('tabindex');
                $(this).attr('tabindex', tabindex);
              });
            },
            "error": function(jqXHR, textStatus, errorThrown) {
            }
          });
          // no need to add cart.requestComplete since it's in cart__form
        });

        if (possible_variants.length === 0) {
          this.selectionIllegal();
        } else if (possible_variants.length === 1 && selection_complete) {
          this.selectionComplete(possible_variants[0]);
        } else {
          this.selectionIncomplete(possible_variants);
        }
      }

      /**
       * Perform events when one valid variant was detected
       *
       * @param {Object} variant - Selected variant
       * @fires VariantSelectorEngine#VariantSelector:selectionComplete
       */

    }, {
      key: 'selectionComplete',
      value: function selectionComplete(variant) {
        /**
         * A selection was triggered, all options were selected, and
         * only one variant could be selected.
         * The selected options correspond to a single variant.
         * The "Happy Path" scenario for variant selection.
         *
         * @event VariantSelectorEngine#VariantSelector:selectionComplete
         * @property {Object} variant - The selected variant
         * @example
         * // Do something when a single variant has been selected
         * $variantSelector.on('VariantSelector:selectionComplete', (event, variant) =>
         *     $atcButton.prop('disabled', !variant.available)
         * );
         *
         * // Do something when not all options have been selected
         * $variantSelector.on('VariantSelector:selectionComplete', (event, variant) =>
         *     // Remind the user to select a color if none were selected
         *     if (variant_selector.variant_options['color'].selected) {
         *         $product_message.empty();
         *     } else {
         *         $product_message.html('Please select a color');
         *     }
         * );
         */
        this.$event_root.trigger('VariantSelector:selectionComplete', variant);
      }

      /**
       * Perform events when no variant was found
       *
       * @fires VariantSelectorEngine#VariantSelector:selectionIllegal
       */

    }, {
      key: 'selectionIllegal',
      value: function selectionIllegal() {
        /**
         * A selection was triggered and no variants could be selected.
         * This could be a case where, for example, the selected color is
         * 'green' and size is 'small,' but no variant exists that is green
         * and small.
         *
         * @event VariantSelectorEngine#VariantSelector:selectionIllegal
         */
        this.$event_root.trigger('VariantSelector:selectionIllegal');
      }

      /**
       * Peform events when multiple variants meet the selection criteria
       *
       * @param {Object[]} possible_variants - List of valid variants for the current selection
       * @fires VariantSelectorEngine#VariantSelector:selectionIncomplete
       */

    }, {
      key: 'selectionIncomplete',
      value: function selectionIncomplete(possible_variants) {
        /**
         * A selection was triggered and multiple variants meet the selection criteria.
         * This would occur in scenarios where, for example, color is 'green' but no size
         * is selected (ie it is undefined). Therefore all variants that are 'green' will
         * be returned.
         *
         * @event VariantSelectorEngine#VariantSelector:selectionIncomplete
         * @property {Object[]} possible_variants - A list of possibly selected variants
         */
        this.$event_root.trigger('VariantSelector:selectionIncomplete', possible_variants);
      }
    }]);

    return VariantSelectorEngine;
  }();

  /**
   * A class to hold a product's option and associated values
   */


  var VariantOption = function () {

    /**
     * @constructs VariantOption
     * @param {Object} option - The option encapsulated by this class
     * @param {string} option.name - The name of the option
     * @param {string} option.position - The 1 indexed position of the option
     * @param {string[]} option.values - The list of values for this option
     * @param {jQuery} $event_root - The trigger origin for events
     */
    function VariantOption(option, $event_root) {
      var _this17 = this;

      _classCallCheck(this, VariantOption);

      this.name = option.name;
      this.option_index = 'option' + option.position;
      this.$event_root = $event_root;

      this.values = option.values.reduce(function (acc, cur) {
        acc[cur] = new VariantOptionElement(cur, _this17.name, _this17.$event_root);
        return acc;
      }, {});

      // Define event names
      this.event_names = {
        selected: 'VariantSelector:selected:' + this.name
      };
    }

    /**
     * @returns {string} The selected value for this option, can be undefined for no selection
     */


    _createClass(VariantOption, [{
      key: 'selected',
      get: function get() {
        if (this._selected) {
          return this._selected.value;
        } else {
          return undefined;
        }
      }

      /**
       * Set the selected value for this option, pass a falsy value to
       * unselect the value for this option
       *
       * @param {string} value - Selected value
       * @fires VariantOption#VariantSelector:selected
       */
      ,
      set: function set(value) {
        if (this._selected) {
          this._selected.deselect();
        }

        if (value) {
          this._selected = this.values[value];
          this._selected.select();
        } else {
          this._selected = undefined;
        }

        /**
         * The selected value for this option has been updated.
         * The name of the event is 'VariantSelector:selected:OPTION_NAME', where
         * 'OPTION_NAME' is the option to listen to.
         * @event VariantOption#VariantSelector:selected
         * @property {string} value - The newly selected value
         * @example
         * // Perform an update when a specific color option is updated
         * $variantSelector.on('VariantSelector:selected:color', (event, value) => $color_message.html('Selected Color: ' + value));
         */
        this.$event_root.trigger(this.event_names.selected, value);
      }
    }]);

    return VariantOption;
  }();

  /**
   * A class to hold a value for an option
   */


  var VariantOptionElement = function () {

    /**
     * @constructs VariantOptionElement
     * @param {string} value - Value name of this value
     * @param {jQuery} $event_root - Origin element for triggering events
     */
    function VariantOptionElement(value, option_name, $event_root) {
      _classCallCheck(this, VariantOptionElement);

      this.value = value;
      this.$event_root = $event_root;

      this._associated_variants = [];

      var event_suffix = ':' + option_name + ':' + value;

      this.event_names = {
        selected: 'VariantSelector:selected' + event_suffix,
        deselect: 'VariantSelector:deselect' + event_suffix,
        activated: 'VariantSelector:activated' + event_suffix,
        deactivated: 'VariantSelector:deactivated' + event_suffix,
        variants_updated: 'VariantSelector:variantsUpdated' + event_suffix
      };
    }

    /**
     * Associate a list of variants for this value of an option
     * If the list is empty then deactivate the value
     *
     * @param {Variant[]} variants - A list of possibly valid variants
     * @fires VariantOptionElement#VariantSelector:variantsUpdated
     */


    _createClass(VariantOptionElement, [{
      key: 'deselect',


      /**
       * Notify listeners that this value is no longer selected
       * @fires VariantOptionElement#VariantSelector:deselect
       */
      value: function deselect() {
        /**
         * This value has been deselected.
         * The name of the event is 'VariantSelector:deselect:OPTION_NAME:OPTION_VALUE', where
         * 'OPTION_NAME' is the option's name and 'OPTION_VALUE' is the respective value to listen to.
         * @event VariantOptionElement#VariantSelector:deselect
         */
        this.$event_root.trigger(this.event_names.deselect);
      }

      /**
       * Notify listeners that this value has been selected
       * @fires VariantOptionElement#selected
       */

    }, {
      key: 'select',
      value: function select() {
        /**
         * This value has been selected
         * The name of the event is 'VariantSelector:selected:OPTION_NAME:OPTION_VALUE', where
         * 'OPTION_NAME' is the option's name and 'OPTION_VALUE' is the respective value to listen to.
         *
         * @event VariantOptionElement#VariantSelector:selected
         * @example
         * // Show and hide an element when green selected
         * $variantSelector.on('VariantSelector:selected:color:green', () =>
         *     $green_badge.show()
         * );
         * $variantSelector.on('VariantSelector:deselect:color:green', () =>
         *     $green_badge.hide()
         * );
         */
        this.$event_root.trigger(this.event_names.selected);
      }

      /**
       * Notify listeners that this value has been deactivated
       * since there are no possible variants that could be selected
       * @fires VariantOptionElement#VariantSelector:deactivated
       */

    }, {
      key: 'deactivate',
      value: function deactivate() {
        /**
         * This value cannot be used to select variants because
         * none exist.
         * The name of the event is 'VariantSelector:deactivated:OPTION_NAME:OPTION_VALUE', where
         * 'OPTION_NAME' is the option's name and 'OPTION_VALUE' is the respective value to listen to.
         *
         * @event VariantOptionElement#VariantSelector:deactivated
         */
        this.$event_root.trigger(this.event_names.deactivated);
      }

      /**
       * Notify listeners that this value has been activated
       * and variants can be selected for
       * @fires VariantOptionElement#VariantSelector:activated
       */

    }, {
      key: 'activate',
      value: function activate() {
        /**
         * This value can be used to select variants.
         * The name of the event is 'variant-selector__activated:OPTION_NAME:OPTION_VALUE', where
         * 'OPTION_NAME' is the option's name and 'OPTION_VALUE' is the respective value to listen to.
         *
         * @event VariantOptionElement#VariantSelector:activated
         * @example
         * // An example where we procedurally set selectors to be enabled/disabled
         * $('product__selector').each((index, element) => {
         *     let $element = $(element);
         *     $variantSelector.on(`VariantSelector:activated:${element.getAttribute('name')}:${element.value}` () =>
         *         $element.removeClass('disabled')
         *     );
         *     $variantSelector.on(`VariantSelector:deactivated:${element.getAttribute('name')}:${element.value}`, () =>
         *         $element.addClass('disabled')
         *     );
         * });
         */
        this.$event_root.trigger(this.event_names.activated);
      }
    }, {
      key: 'associated_variants',
      set: function set(variants) {
        if (!variants || variants.length === 0) {
          this.deactivate();
        } else {
          this.activate();
        }

        this._associated_variants = variants || [];

        /**
         * A list of variants has been associated to this value.
         * The name of the event is 'ariantSelector:variantsUpdated:OPTION_NAME:OPTION_VALUE', where
         * 'OPTION_NAME' is the option's name and 'OPTION_VALUE' is the respective value to listen to.
         * @event VariantOptionElement#VariantSelector:variantsUpdated
         * @property {Variant[]} variants - Variants that could be selected
         * @example
         * // An example where we use variantsUpdated to set stock values for option selectors
         * // to for example show them in a tooltip
         * $('product__selector-size').each((index, element) => {
         *     let $element = $(element);
         *     $variantSelector.on('VariantSelector:variantsUpdated:size:' + element.value, (event, variants) => {
         *         // Variants.length should be 0 or 1 since in this example 'size'
         *         // is the last option
         *         if (variants.length > 0) {
         *             $element.data('stock', variants[0].inventory_quantity);
         *         }
         *     });
         * });
         */
        this.$event_root.trigger(this.event_names.variants_updated, variants);
      },
      get: function get() {
        return this._associated_variants;
      }
    }]);

    return VariantOptionElement;
  }();

  theme.VariantSelector = VariantSelector;

  // Initialize variant selectors on the page.
  $(function () {
    theme.product_vs = $('.js-product-container').get().reduce(function (acc, element) {
      var $element = $(element);
      acc[$element.data('product-handle')] = new VariantSelector($element);

      return acc;
    }, {});
  });
})(window.theme = window.theme || {}, jQuery);

/**
 * STICKY LIBRARY
 *
 * @description Handles sticky elements.
 * @namespace sticky
 */

(function (theme, $) {

  /**
   * Class representing the sticky object.
   *
   * @classdesc The Sticky class is used to create sticky objects out of elements with the class <code>js-sticky</code>. The <code>js-stuck</code> class is added once the element reaches the top of the document on scroll.
   * <br><br>
   * Breakpoints may be passed optionally as the data-sticky attribute, in json format
   * <br><br>
   * @example <div class="js-sticky"></div>
   * @example <div class="js-sticky" data-sticky='{"min":"768"}'></div>
   * @example <div class="js-sticky" data-sticky='{"min":"425","max":"768"}'></div>
   *
   * @property {object} [options] - Optional breakpoints
   * @property {integer} [options.max] - Disable sticky at screen sizes larger than this breakpoint; extracted from options
   * @property {integer} [options.min] - Disable sticky at screen sizes smaller than this breakpoint; extracted from options
   * @property {jQuery} $sticky - The sticky element
   * @property {boolean} disabled - Indicates if the sticky is disabled based on breakpoints
   * @property {integer} offset - Distance from the top of the element to the top of the document. Minimum 0.
   * @property {boolean} stuck - Indicates if the sticky is stuck
  */
  var Sticky = function () {
    /**
     * Creates an instance of Sticky.
     *
     * @param {jQuery} $element - The sticky element
     * @constructs Sticky
     * @memberof Sticky
     */
    function Sticky($element) {
      _classCallCheck(this, Sticky);

      if (!$element) {
        console.error('Sticky.constructor: No element was passed.');
        return false;
      }

      this.$sticky = $element;
      this.options = $element.data('sticky') || {};
      this.max = this.options.hasOwnProperty('max') && Math.floor(this.options.max) != this.options.max && !$.isNumeric(this.options.max) || this.max < 0 ? -1 : this.options.max;
      this.min = this.options.hasOwnProperty('min') && Math.floor(this.options.min) != this.options.min && !$.isNumeric(this.options.min) || this.options.min < 0 ? -1 : this.options.min;
      this.disabled = this._isDisabled();
      this.offset = Math.max($element.offset().top, 0);
      this.stuck = false;

      this._run();
    }

    // ------------------------------
    //  Methods
    // ------------------------------

    /**
     * Internal method that handles the main functionality of the sticky object. Calls the <code>update()</code> on document scroll and <code>refresh()</code> on window resize.
     *
     * @private
     * @memberof Sticky
     */


    _createClass(Sticky, [{
      key: '_run',
      value: function _run() {
        var _this18 = this;

        this.update();

        $(document).scroll($.throttle(250, function () {
          _this18.update();
        }));

        $(window).resize($.throttle(250, function () {
          _this18.refresh();
        }));
      }

      /**
       * Internal method that checks if the sticky is disabled based on breakpoints passed as options.
       *
       * @private
       * @memberof Sticky
       */

    }, {
      key: '_isDisabled',
      value: function _isDisabled() {
        if (this.max == -1 || this.min == -1) {
          return true;
        }
        return this.max < $(window).width() || this.min > $(window).width();
      }

      /**
       * Checks if the sticky element is disabled, then sticks or unsticks the element according to the offset.
       *
       * @memberof Sticky
       */

    }, {
      key: 'update',
      value: function update() {
        if (this.disabled) {
          return false;
        }
        $(document).scrollTop() > this.offset ? this.stick() : this.unstick();
      }

      /**
       * Calculates the offset of the sticky element from the top of the document and calls the update function if the element is not disabled.
       *
       * @memberof Sticky
       */

    }, {
      key: 'refresh',
      value: function refresh() {
        this.offset = Math.max(this.$sticky.offset().top, 0);
        this.disabled = this._isDisabled();
        if (this.disabled) {
          this.update();
        }
      }

      /**
       * Sticks the sticky element.
       *
       * @fires Sticky:stick
       * @memberof Sticky
       */

    }, {
      key: 'stick',
      value: function stick() {
        /**
         * Adds the class <code>js-stuck</code> class to the sticky element.
         *
         * @event Sticky:stick
         * @memberof Sticky
         */
        this.stuck = true;
        this.$sticky.addClass('js-stuck').trigger('Sticky:stick');
      }

      /**
       * Unsticks the sticky element.
       *
       * @fires Sticky:unstick
       * @memberof Sticky
       */

    }, {
      key: 'unstick',
      value: function unstick() {
        /**
         * Removes the class <code>js-stuck</code> from the sticky element.
         *
         * @event Sticky:unstick
         * @memberof Sticky
         */
        this.stuck = false;
        this.$sticky.removeClass('js-stuck').trigger('Sticky:unstick');
      }
    }]);

    return Sticky;
  }();

  // ------------------------------
  //  Initiallization
  // ------------------------------

  theme.Sticky = Sticky;

  $('.js-sticky').each(function () {
    new theme.Sticky($(this));
  });
})(window.theme = window.theme || {}, jQuery);

/**
 * FLYOUT LIBRARY
 *
 * @description Handles flyout elements.
 * @namespace flyout
 */
(function (theme, $) {

  /**
   * Class names.
   *
   * @private
   * @const
   * @type {Object}
   */
  var CLASSES = {
    noScroll: 'noscroll',
    lockMenu: 'lock-menu',
    flyoutActive: {
      left: 'flyout-active-left',
      right: 'flyout-active-right',
      top: 'flyout-active-top'
    }

    /**
     * Class representing a flyout element.
     *
     * @classdesc Creates Flyout objects out of elements with the class <code>js-flyout</code> and the data attribute <code>data-flyout-id</code>, where the value is a unique id. The element can optionally have a <code>data-flyout-options</code> attribute, where the value is a JSON object that can have
     *<br><br>
     * 1) a <code>max</code> and/or <code>min</code> property with a value, indicating the maximum or minimum screensize (in pixels) on which the flyout will be enabled.
     * <br>
     * 2) a <code>direction</code> property with the value <code>left</code> or <code>right</code>, which indicates which side the flyout will display from. The default direction is <code>right</code>.
     * <br><br>
     * A Flyout object requires trigger elements to open/close the flyout, with the data attribute <code>data-flyout-open</code>, <code>data-flyout-close</code>, or <code>data-flyout-toggle</code>. The value of the data attribute must be the data-flyout-id of the flyout element being targeted
     *
     * @example
     * <div class="flyout js-flyout" data-flyout-id="my-flyout" data-flyout-options='{"direction":"right","max":500,"min":200}'>
     * This Is My Flyout
     * </div>
     * <button data-flyout-toggle="my-flyout">Toggle Flyout</button>
     *
     * @property {object} elements - Contains the flyout and its triggers
     * @property {string} id - The flyout ID
     * @property {json} options - options for the flyout
     * @property {string} [options.direction] - direction from which the flyout will appear
     * @property {string} [options.max] - max screen width at which this will be enabled
     * @property {string} [options.min] - min screen width at which this will be enabled
     * @property {string} direction - Optional direction extracted from options; default is right
     * @property {string} max - Optional max extracted from options
     * @property {string} min - Optional min extracted from options
     */

  };
  var Flyout = function () {

    /**
     * Creates an instance of Flyout.
     *
     * @param {jQuery} $flyout - The flyout element.
     * @constructs Flyout
     * @memberof flyout
     */
    function Flyout($flyout) {
      _classCallCheck(this, Flyout);

      if (!$flyout) {
        console.error('Flyout.constructor: No element was passed.');
        return false;
      }

      this.elements = {
        flyout: $flyout
      };
      this.id = $flyout.data('flyout-id') || false;
      this.options = $flyout.data('flyout-options') || false;

      // the id of the element to focus on when the flyout opens
      this.focus = $flyout.data('focus-target-id') || false;

      this.direction = this.options.direction && (this.options.direction == 'left' || this.options.direction == 'right' || this.options.direction == 'top') ? this.options.direction : 'right';

      this.max = this.options.max && Math.floor(this.options.max) != this.options.max && !$.isNumeric(this.options.max) || this.max < 0 ? -1 : this.options.max;
      this.min = this.options.min && Math.floor(this.options.min) != this.options.min && !$.isNumeric(this.options.min) || this.options.min < 0 ? -1 : this.options.min;

      this.disabled = this._isDisabled();
      this.$overlay = $('.js-flyout-overlay');
      this.hidden = false;
      this.current_window_width = $(window).width();

      if (this.id) {
        this._bindTriggers();
        this._addRoles();
        this._hideFlyout();
        this._run();
      }
    }
    // ------------------------------
    //  Methods
    // ------------------------------

    /**
     *  Listens and re-checks on window resize to see if the flyout should be disabled
     *
     * @private
     * @memberof Flyout
     */


    _createClass(Flyout, [{
      key: '_run',
      value: function _run() {
        var _this19 = this;

        $(window).resize($.debounce(250, function () {
          _this19._refresh();
          // close if flyout is switching between breakpoints
          var new_window_width = $(window).width();
          if (new_window_width < window.theme.breakpoints.m && _this19.current_window_width >= window.theme.breakpoints.m) {
            _this19.close();
            _this19.current_window_width = new_window_width;
          } else if (new_window_width >= window.theme.breakpoints.m && _this19.current_window_width < window.theme.breakpoints.m) {
            _this19.close();
            _this19.current_window_width = new_window_width;
          }
        }));
      }
      /**
       * checks to see if flyout should be disabled, rebinds triggers, hides the flyout.
       *
       * @private
       * @memberof Flyout
       */

    }, {
      key: '_refresh',
      value: function _refresh() {
        this.disabled = this._isDisabled();
        this._bindTriggers();
        this._addRoles();
      }

      /**
       * Checks if window size is smaller than min or larger than max.
       *
       * @private
       * @memberof Flyout
       */

    }, {
      key: '_isDisabled',
      value: function _isDisabled() {
        if (this.max == -1 || this.min == -1) {
          return true;
        }
        return this.max < $(window).width() || this.min > $(window).width();
      }

      /**
       * Adds accessibility roles to a trigger element.
       *
       * @param {jQuery} $elem - The trigger to check for accessibility roles.
       * @private
       * @memberof Flyout
       */

    }, {
      key: '_addRole',
      value: function _addRole($elem) {
        if ($elem.prop('tagName') != 'BUTTON' && $elem.attr('type') != 'submit' && !$elem.attr('role') && !$elem.attr('aria-role')) {
          $elem.attr('role', 'button');
        }
      }

      /**
       * Adds accessibility roles to all trigger elements. Must be run after this._bindTriggers.
       *
       * @private
       * @memberof Flyout
       */

    }, {
      key: '_addRoles',
      value: function _addRoles() {
        var _this20 = this;

        $([this.elements.toggle, this.elements.open, this.elements.close]).each(function (index, element) {
          _this20._addRole($(element));
        });
      }

      /**
       * Internal method that binds flyout triggers, based on the flyout element's ID, and adds them to <code>flyout.elements</code>. Handles click events. Note that trigger elements which are loaded through AJAX will have to be re-bound.
       *
       * @private
       * @memberof Flyout
       */

    }, {
      key: '_bindTriggers',
      value: function _bindTriggers() {
        var _this21 = this;

        this.elements.toggle = $.find('[data-flyout-toggle=' + this.id + ']');
        this.elements.open = $.find('[data-flyout-open=' + this.id + ']');
        this.elements.close = $.find('[data-flyout-close=' + this.id + ']');

        if (this.disabled) {
          $(this.elements.toggle).off('click.flyout');
          $(this.elements.open).off('click.flyout');
          $(this.elements.close).off('click.flyout');
          return false;
        }

        $(this.elements.toggle).off('click.flyout').on('click.flyout', function (event) {
          event.preventDefault();
          _this21.toggle();
        });

        $(this.elements.open).off('click.flyout').on('click.flyout', function (event) {
          event.preventDefault();
          _this21.open();
        });

        this.$overlay.on('click.flyout', function (event) {
          if (!$(event.target).closest('.flyout').length) {
            _this21.close();
          }
        });

        $(this.elements.close).off('click.flyout').on('click.flyout', function (event) {
          event.preventDefault();
          _this21.close();
        });

        $(document).on('keydown', function (event) {
          if (event.keyCode === 27) {
            event.preventDefault();
            _this21.close();
          }
        });
      }

      /**
       * Internal method that hides the flyout element based on the direction it will open from.
       *
       * @private
       * @memberof Flyout
       */

    }, {
      key: '_hideFlyout',
      value: function _hideFlyout() {
        if (this.disabled) {
          this.elements.flyout.hide().removeClass(CLASSES.flyoutActive[this.direction]);

          this.hidden = false;
          $('body').removeClass(CLASSES.noScroll);
          return false;
        }

        // Hide the flyout if it hasn't already been hidden.
        if (!this.hidden) {
          this.elements.flyout.removeClass(CLASSES.flyoutActive[this.direction]);
          this.elements.flyout.hide();
          this.hidden = true;
        }
      }

      /**
       * Opens the flyout in the specified direction. Adds the class <code>flyout-active-${direction}</code> to the flyout element, removes the class <code>flyout-hidden-${direction}</code>.
       *
       * @fires Flyout:open
       * @memberof Flyout
       */

    }, {
      key: 'open',
      value: function open() {
        var _this22 = this;

        /**
         * A flyout element has been opened. Event is attached to a .js-flyout element.
         *
         * @event Flyout:open
         * @memberof Flyout
         * @example
         * $(.js-flyout).on('Flyout:open', function(event) { });
         */
        theme.flyoutManager.forEach(function (flyout) {
          if (!flyout.hidden) {
            flyout.close();
          }
        });

        // a lil lazy reset
        $('.js-header').removeClass('has-search-open');
        this.$overlay.css('top', 0);

        this.elements.flyout.off();

        // overlay reset
        this.$overlay.off();
        this.$overlay.on('click.flyout', function (event) {
          if (!$(event.target).closest('.flyout').length) {
            _this22.close();
          }
        });

        $('body').addClass(CLASSES.noScroll);

        var focus = this.focus;
        this.elements.flyout.show();

        setTimeout(function () {

          _this22.elements.flyout.addClass(CLASSES.flyoutActive[_this22.direction]).on('transitionend webkittransitionEnd otransitionEnd MStransitionEnd', function (e) {
            _this22.elements.flyout.trigger('Flyout:open');
            _this22.elements.flyout.off(e);

            if (focus) {
              document.getElementById(focus).focus();
            }
          });
        }, 10);

        if (this.direction == 'top') {
          $('.js-header').addClass('has-search-open');
          this.$overlay.css('top', $('.js-header').height());
        }

        this.$overlay.removeClass('hidden').show();

        if (this.focus) {
          document.getElementById(this.focus).focus();
        }

        this.hidden = false;
        this.toggleMegaMenu();
      }

      /**
       * Closes the flyout in the opposite direction from which it opened.
       * Removes the <code>flyout-active-${direction}</code> class from the flyout element, adds the <code>flyout-hidden-${direction}</code> class.
       *
       * @fires Flyout:close
       * @memberof Flyout
       */

    }, {
      key: 'close',
      value: function close() {
        var _this23 = this;

        $('body').removeClass(CLASSES.noScroll);
        this.elements.flyout.removeClass(CLASSES.flyoutActive[this.direction]).one('transitionend webkittransitionEnd otransitionEnd MStransitionEnd', function (e) {
          _this23.elements.flyout.hide();
        });

        /**
         * A flyout element has been closed. Event is attached to a .js-flyout element.
         *
         * @event Flyout:close
         * @memberof Flyout
         * @example
         * $(.js-flyout).on('Flyout:close', function(event) { });
         */

        this.elements.flyout.one('transitionend webkittransitionEnd otransitionEnd MStransitionEnd', function (e) {

          // checks if the element was being closed when the transition ended.
          // prevents bugs where we close and open the flyout fast, so that the transition finishes on an open flyout.
          var $target = $(e.target);
          if (!$target.hasClass(CLASSES.flyoutActive[_this23.direction])) {
            $target.trigger('Flyout:close');
          }
        });

        this.$overlay.addClass('hidden');

        this.$overlay.one('transitionend webkittransitionEnd otransitionEnd MStransitionEnd', function (e) {
          _this23.$overlay.hide();
        });

        this.hidden = true;
        this.toggleMegaMenu();
      }

      /**
       * Toggles the flyout depending on its current state.
       *
       * @memberof Flyout
       * @fires Flyout:toggle
       */

    }, {
      key: 'toggle',
      value: function toggle() {

        /**
         * A flyout element has been toggled. Event is attached to a .js-flyout element.
         *
         * @event Flyout:toggle
         * @memberof Flyout
         * @example
         * $(.js-flyout).on('Flyout:toggle', function(event) { });
         */

        this.elements.flyout.trigger('Flyout:toggle');

        if (!this.hidden) {
          this.close();
        } else {
          this.open();
        }
      }
      /**
       * Toggles Mega Menu locking so that mega menu submenus don't open when a flyout is open
       * @memberof Flyout
       * Must be called at the very end of open() & close()
       * */

    }, {
      key: 'toggleMegaMenu',
      value: function toggleMegaMenu() {
        if (this.hidden) {
          $('.js-menu').removeClass(CLASSES.lockMenu);
        } else {
          $('.js-menu').addClass(CLASSES.lockMenu);
        }
      }
    }]);

    return Flyout;
  }();

  // ------------------------------
  //  Initialization
  // ------------------------------

  theme.Flyout = Flyout;

  $('.js-flyout').each(function () {
    theme.flyoutManager = theme.flyoutManager || [];
    theme.flyoutManager.push(new theme.Flyout($(this)));
  });
})(window.theme = window.theme || {}, jQuery);

/**
 * DROPDOWN LIBRARY
 *
 * @description Handles all dropdown functionality.
 * @namespace theme.Dropdown
 */
(function (theme, $) {
  /**
   * Default settings.
   *
   * @private
   * @const
   * @type {Object}
   */
  var DEFAULTS = {
    closeMenuOnSelect: false,
    showSelectionInLabel: true
  };

  /**
   * Class selectors.
   *
   * @private
   * @const
   * @type {Object}
   */
  var CLASSES = {
    active: 'active',
    open: 'open'
  };

  /**
   * Creates an DropdownOption object representing an option in a dropdown list.
   *
   * @classdesc will be accessed by Dropdown class constructor
   * @property {string} value - The html content of $element
   * @property {jQuery[]} elements - The DOM elements constituting the DropdownOption. Generally has only one item.
   * @property {jQuery} elements.option - The main DOM element.
   */

  var DropdownOption = function () {
    /**
     * Creates an instance of DropdownOption.
     *
     * @param {jQuery} $element - The DOM element to initialize on.
     * @param {number} [id] - The id to add to the element.
     * @constructs DropdownOption
     * @memberof DropdownOption
     */
    function DropdownOption($element, id) {
      var _this24 = this;

      _classCallCheck(this, DropdownOption);

      if (!$element) {
        return false;
      }

      this.value = $element.html();

      this.elements = {
        option: $element

        // Assign a unique id to the option
      };if (id) {
        this.elements.option.data('option-id', id);
      }

      // Add event listeners that calls set()
      this.elements.option.off('click.Dropdown').on('click.Dropdown', function () {
        _this24.set();
      });
    }

    /**
     * Is set to happen on click, triggers an event.
     *
     * @fires DropdownOption:set
     * @memberof DropdownOption
     */


    _createClass(DropdownOption, [{
      key: 'set',
      value: function set() {
        this.elements.option.trigger('DropdownOption:set', this.value);
      }
    }]);

    return DropdownOption;
  }();

  /**
   * Class representing the dropdown.
   *
   * @classdesc makes Dropdowns. <br><br>
   * Usage: executed on a dropdown container element with the class <code>js-dropdown</code>, containing
   * <ol>
   *   <li> a label element with the class <code>js-dropdown-label</code> </li> <li> a list element with the class <code>js-dropdown-list</code>, or a  <code>ul</code> element. Must contain child elements with the class <code>js-dropdown-option</code>, or <code>li</code> elements.</li>
   *   <li>Can also contain an optional trigger element with the class <code>js-dropdown-trigger</code> which will toggle the dropdown menu open and closed- if none are found, this will default to the label element.</li>
   * </ol>
   * <br><br>
   * The <code>js-dropdown</code> container element can optionally have a data-dropdown-settings attribute in JSON format, to set behaviour for this dropdown. Consult constructor documentation for setting names and values.
   *
   * @example
   * <div class="js-dropdown">
   *   <span class="js-dropdown-label">Dropdown Title</span>
   *   <ul class="js-dropdown-list">
   *     <li class="js-dropdown-option">Option 1</li>
   *     <li class="js-dropdown-option">Option 2</li>
   *     <li class="js-dropdown-option">Option 3</li>
   *   </ul>
   * </div>
   *
   * @property {boolean} expanded - Boolean which determines whether the dropdown is open or closed.
   * @property {object} options - Keeps track of the dropdown's options, represented as DropdownOption instances.
   * @property {array} elements - An array of DOM elements that are parts of the dropdown.
   * @property {jQuery} elements.dropdown - The dropdown container DOM element
   * @property {jQuery} elements.list - The dropdown list DOM element, identified by class '.js-dropdown-list'. If none are found, it will be set to any <code>ul</code> child element of the $dropdown container element.
   * @property {jQuery} elements.label - The dropdown label DOM element, identified by class '.js-dropdown-label'.
   * @property {jQuery} [elements.trigger=elements.label] - The DOM element to trigger the menu to open or close, identified by class '.js-dropdown-trigger'. If not set,default will be the label element.
   * @property {jQuery} $selected - Holds the DOM element which displays the currently selected option.
   * @property {Option} _selected_option - Holds the DropdownOption instance corresponding to the currently selected option
   */


  var Dropdown = function () {
    /**
     * Creates an instance of Dropdown.
     *
     * @constructs Dropdown
     * @param {jQuery} $dropdown - The dropdown container DOM element.
     * @param {object} settings - settings to be set on the dropdown. Derived from, in order of descending importance: The data-dropdown-settings attribute of the $dropdown element, the settings passed into the constructor, and the default settings.
     * @param {boolean} [settings.closeMenuOnSelect = false] - if true, menu will close when an option is chosen.
     * @param {boolean} [settings.showSelectionInLabel = true] - if true, label will change to show currently selected option.
     * @memberof Dropdown
     */
    function Dropdown($dropdown, settings) {
      var _this25 = this;

      _classCallCheck(this, Dropdown);

      this.expanded = false;
      this._selected_option;

      var dropdownSettings = $dropdown.data('dropdown-settings');
      this.settings = $.extend({}, DEFAULTS, settings, dropdownSettings);

      this.elements = {
        dropdown: $dropdown,
        list: $dropdown.find('.js-dropdown-list').length ? $dropdown.find('.js-dropdown-list') : $dropdown.find('ul'),
        label: $dropdown.find('.js-dropdown-label'),
        trigger: $dropdown.find('.js-dropdown-trigger')

        // If no trigger is specified, use the label
      };if (this.elements.trigger.length === 0) {
        this.elements.trigger = this.elements.label;
      }

      this.bindOptions();

      // Trigger toggle event handler
      this.elements.trigger.off('click.Dropdown').on('click.Dropdown', function () {
        _this25.toggle();
      });

      // When clicking away from the dropdown, close this menu if it's expanded.
      $(document).on('click.Dropdown', function (e) {
        var $clicked_elements = $(e.target).parents().addBack();
        if (!$clicked_elements.is(_this25.elements.dropdown)) {
          if (_this25.expanded) {
            _this25.close();
          }
        }
      });
    }

    // ------------------------------
    //  Getters and Setters
    // ------------------------------

    /**
     * The DOM element corresponding to the currently selected dropdown option. Has a setter and a getter.
     * The setter expects a DOM element as argument, and will also set this._selected_option, add the 'active' class to the DOM element, and change the label DOM element to display the same HTML as the selected element.
     *
     * @type {jQuery}
     * @fires Dropdown:update
     * @memberof Dropdown
     */


    _createClass(Dropdown, [{
      key: 'bindOptions',


      // ------------------------------
      //  Methods
      // ------------------------------

      /**
       * Consolidates all the list options on the dropdown, and populates this.options with DropdownOption objects.
       *
       * @memberof Dropdown
       */
      value: function bindOptions() {
        var _this26 = this;

        var _ = this;
        this.options = {};
        this.elements.options = this.elements.list.find('.js-dropdown-option').length ? this.elements.list.find('.js-dropdown-option') : this.elements.list.find('li');
        this.elements.options.each(function (index, element) {
          var id = theme.utils.uniqueNumber();
          _this26.options[id] = new DropdownOption($(element), id);
        });

        /*
         * When DropdownOption fires its DropdownOption:set event from a click on an option element, set this.$selected to that option element.
         * See also: the setter function for $selected, which will execute as a result of this.
         * If closeMenuOnSelect is true, this will also close the menu.
         */
        this.elements.options.on('DropdownOption:set', function () {
          if (_.settings.closeMenuOnSelect) {
            _.close();
          }
          if (!$(this).hasClass('js-option-disabled')) {
            _.$selected = $(this);
          }
        });
      }

      /**
       * Opens the dropdown menu.
       *
       * @fires Dropdown:open
       * @memberof Dropdown
       */

    }, {
      key: 'open',
      value: function open() {
        this.expanded = true;
        this.elements.list.slideDown();

        /**
         * The dropdown element has opened.
         *
         * @event Dropdown:open
         */
        this.elements.dropdown.addClass(CLASSES.open).trigger('Dropdown:open');
        this.elements.dropdown.find('.menu').addClass(CLASSES.open);
      }

      /**
       * Closes the dropdown menu.
       *
       * @fires Dropdown:close
       * @memberof Dropdown
       */

    }, {
      key: 'close',
      value: function close() {
        this.expanded = false;
        this.elements.list.slideUp();

        /**
         * The dropdown element has closed.
         *
         * @event Dropdown:close
         */

        this.elements.dropdown.removeClass(CLASSES.open).trigger('Dropdown:close');
        this.elements.dropdown.find('.menu').removeClass(CLASSES.open);
      }

      /**
       * Determines whether the dropdown menu should be opened or closed.
       *
       * @memberof Dropdown
       * @fires Dropdown:toggle
       */

    }, {
      key: 'toggle',
      value: function toggle() {
        if (this.expanded) {
          this.close();
        } else {
          this.open();
        }

        /**
         * The dropdown element has been toggled.
         *
         * @event Dropdown:toggle
         */
        this.elements.dropdown.trigger('Dropdown:toggle');
      }
    }, {
      key: '$selected',
      set: function set($option) {
        if (!$option || !$option.data('option-id')) {
          return false;
        }

        var option_id = $option.data('option-id');
        // Get the DropdownOption object in this.options with the same id
        var option = this.options[option_id];

        // update this._selected_option to that DropdownOption Object
        this._selected_option = option;

        // Updates active classes on the options
        this.elements.options.not($option).removeClass(CLASSES.active);
        option.elements.option.addClass(CLASSES.active);

        // Change label to display the clicked value
        if (this.settings.showSelectionInLabel) {
          this.elements.label.html(option.value);
        }

        // Fire an event that returns the DropdownOption object
        this.elements.dropdown.trigger('Dropdown:update', option);
      }

      /**
       * The currently selected option has changed.
       *
       * @event Dropdown:update
       */
      ,
      get: function get() {
        return this._selected_option;
      }
    }]);

    return Dropdown;
  }();

  // Global export.


  theme.Dropdown = Dropdown;

  // Initialize dropdowns on the page.
  $('.js-dropdown').each(function () {
    new Dropdown($(this));
  });
})(window.theme = window.theme || {}, jQuery);
/**
 * MULTILINGUAL
 *
 * @description Utilities for multilingual page elements
 */

(function (theme, $) {
  var SELECTORS = {
    toggleSelect: '.js-ml-toggle', // Element containing language toggle links
    checkoutLinks: 'a[href="/checkout"], button[href="/checkout"], .js-checkout-link' // Elements that can link to checkout
  };

  /**
   * Class representing multilingual functionality.
   *
   * @classdesc controls language behaviour across the site. <br><br>
   * Usage: executes itself and targets elements with class <code>js-ml-toggle</code> that contain anchor tags.
   * <ol>
   *   <li> the anchor tags must have a data attribute that contains the locale called <code>data-locale</code> </li>
   * </ol>
   * <br><br> Adds itself into the theme.multilingual object.
   *
   * @example
   * <select class="js-ml-toggle">
   *   <option data-href="/" data-locale="en-CA">English</option>
   *   <option data-href="/" data-locale="fr-CA">French</option>
   * </select>
   *
   * <a href="/checkout" class="js-checkout-link">Checkout</a>
   * <a href="/checkout">Checkout</a>
   * <button href="/checkout">Checkout</a>
   *
   * <script>
   *  let ml = new ML();
   * </script>
   *
   * @property {array} elements - An array of DOM elements that are parts of multilingual.
   * @property {jQuery} elements.toggles - A jQuery array of language toggles present on the page, identified by class '.js-ml-toggle'.
   * @property {string} checkout_link - The checkout link that that the user should be redirected to.
   */

  var ML = function () {
    /**
     * Creates an instance of ML.
     *
     * @constructs ML
     * @memberof ML
     */
    function ML() {
      var _this27 = this;

      _classCallCheck(this, ML);

      this.elements = {};
      this.checkout_link;

      this._bindToggles();
      this._loadFromURL();
      this._loadFromNavigator();
      this._getCheckoutURL();
      this._bindCheckout();

      $(document).on('Cart:set', function () {
        return _this27._getCheckoutURL();
      });
      $(document).on('AjaxCart:set', function () {
        return _this27._bindCheckout();
      });
    }

    /**
     * Handles click events on language toggle links. Updates the language in the cart and then loads the appropriate page.
     *
     * @private
     * @memberof ML
     */


    _createClass(ML, [{
      key: '_bindToggles',
      value: function _bindToggles() {
        this.elements.toggles = $(SELECTORS.toggleSelect);
        this.elements.toggles.on('change', function () {
          var _this28 = this;

          var locale = $(this).find('input[name=languages]:checked').data('locale');
          if (theme.multilingual.settings.locales_supported.indexOf(locale) > -1) {
            theme.cart.updateAttributes({
              _locale: locale
            }, {
              silent: true
            }).then(function () {
              localStorage.setItem('user_locale', locale);
              var redirect_url = $(_this28).find('input[name=languages]:checked').data('href') || window.location.href;

              // Changes GiftReggies' wishlist language
              if (location.pathname.indexOf('apps/giftregistry/wishlist/') >= 0) {
                theme.utils.setURLParams({
                  lang: locale.split('-')[0]
                });
                location.reload();
              } else {
                window.location.href = redirect_url;
              }
            });
          }
        });
      }

      /**
       * Checks if the user should be redirected to the ReCharge checkout.
       * Else, adds locale to Shopify Checkout.
       *
       * @private
       * @memberof ML
       */

    }, {
      key: '_getCheckoutURL',
      value: function _getCheckoutURL() {
        var subscription = false;
        var checkout_link = '';

        theme.cart.content.items.forEach(function (item) {
          if (item.properties && item.properties.subscription_id && item.properties.shipping_interval_frequency && item.properties.shipping_interval_unit_type) {
            subscription = true;
          }
        });

        if (subscription) {
          var myshopify_domain = window.location.hostname;
          var token = (document.cookie.match('(^|; )cart=([^;]*)') || 0)[2];
          var ga_linker = void 0;
          try {
            ga_linker = ga.getAll()[0].get('linkerParam');
          } catch (e) {
            ga_linker = '';
          }
          var customer_param = '';
          // ReCharge checkout
          checkout_link = 'https://checkout.rechargeapps.com/r/checkout?myshopify_domain=' + myshopify_domain + '&cart_token=' + token + '&' + ga_linker + '&' + customer_param;
        } else {
          // Shopify checkout
          checkout_link = '/checkout?locale=' + theme.multilingual.current.language;
        }

        this.checkout_link = checkout_link;
      }

      /**
       * Binds the event listener that sends the user to the appropriate checkout.
       *
       * @private
       * @memberof ML
       */

    }, {
      key: '_bindCheckout',
      value: function _bindCheckout() {
        var _this29 = this;

        $(SELECTORS.checkoutLinks).on('click', function (event) {
          event.preventDefault();

          /*if (fbq) {
            fbq('track', 'InitiateCheckout');
          }*/

          window.location.href = _this29.checkout_link;
        });
      }

      /**
       * Updates the current language when the appropriate URL parameter is present.
       *
       * @private
       * @memberof ML
       */

    }, {
      key: '_loadFromURL',
      value: function _loadFromURL() {
        // If the URL param is allowed by settings
        if (theme.multilingual.settings.allow_locale_url_param) {
          var params = theme.utils.getURLParams();
          var url_locale = params[theme.multilingual.settings.locale_url_param_key];

          // If we found a URL locale
          if (url_locale) {
            // don't do anything if the locale is the current one
            if (this.elements.toggles.find('[data-locale="' + url_locale + '"]:checked').length) {
              return;
            }
            // Attempt to just trigger an existing language toggle link for this locale
            // This will let us piggyback on the current page's corresponding translated URL
            if (this.elements.toggles.length && $(this.elements.toggles).find('[data-locale="' + url_locale + '"]:not(:checked)').length) {
              $('[data-locale="' + url_locale + '"]').prop('checked', true);
              this.elements.toggles.change();
            }

            // If there are no language toggles, do the cart locale update manually
            else if (theme.multilingual.settings.locales_supported.indexOf(url_locale) > -1) {
                theme.cart.updateAttributes({
                  _locale: url_locale
                }, {
                  silent: true
                }).then(function () {
                  window.location.href = window.location.pathname;
                });
              }
          }
        }
      }

      /**
       * Attempt to set the site's language to the user's browser language setting.
       *
       * @private
       * @memberof ML
       */

    }, {
      key: '_loadFromNavigator',
      value: function _loadFromNavigator() {
        // If loading language based on the navigator's language setting is allowed
        if (theme.multilingual.settings.allow_navigator_locale) {
          // Do nothing if this has already been attempted
          if (!Cookies.get('ml_navigator_lang')) {
            Cookies.set('ml_navigator_lang', true);

            // First check that there isn't a URL parameter. If there is one, do nothing.
            if (theme.multilingual.settings.allow_locale_url_param && theme.utils.getURLParams()[theme.multilingual.settings.locale_url_param_key]) return;

            var navigator_locale = navigator && navigator.language,
                navigator_language = navigator_locale && navigator_locale.split('-')[0];

            // If we found a language and it's not the current one
            if (navigator_language && !this.elements.toggles.find('[data-locale^="' + navigator_language + '"]:checked').length) {
              // Attempt to just trigger an existing language toggle link for this language
              // This will let us piggyback on the current page's corresponding translated URL
              if (this.elements.toggles.length && $(this.elements.toggles).find('[data-locale^="' + navigator_language + '"]:not(:checked)').length) {
                $('[data-locale^="' + navigator_language + '"]').prop('checked', true);
                this.elements.toggles.change();
              }

              // If there are no language toggles, do the cart locale update manually
              else if (theme.multilingual.settings.locales_supported.indexOf(navigator_locale) > -1) {
                  theme.cart.updateAttributes({
                    _locale: navigator_locale
                  }, {
                    silent: true
                  }).then(function () {
                    window.location.href = window.location.pathname;
                  });
                }
            }
          }
        }
      }
    }]);

    return ML;
  }();

  $(function () {
    theme.multilingual.ML = new ML();
  });
})(window.theme = window.theme || {}, jQuery);

/**
 * ACCOUNT LIBRARY
 *
 * @description Handles account login and registration, as well as display / template logic for these pages.
 * AJAX login & validation logic could be written here if required.
 * @namespace theme.account
 */

(function (theme, $) {

  var CLASSES = {
    screen: '.js-entry-screen',
    screenToggle: '.js-toggle-entry-screen',
    hiddenClass: 'js-hide',
    addressForm: '.form--customer-address'
  };

  var Account = function () {

    /**
     * Creates an instance of Account.
     *
     * @constructs Account
     */
    function Account() {
      _classCallCheck(this, Account);

      /**
       * Handlers
       */
      var _this = this;

      $(document).on('click', CLASSES.screenToggle, function (e) {
        _this.toggleResetScreen();
      });

      $(CLASSES.addressForm).each(function () {
        _this.initAddresses(this);
      });

      $('.js-open-address-modal').on('click', function () {
        var $this = $(this);
        var address_modal = new theme.Modal($this.data('modal-target'), $this.data('modal-options'));
        address_modal.show();
      });
    }

    _createClass(Account, [{
      key: 'initAddresses',
      value: function initAddresses(form) {
        var $form = $(form);
        new Shopify.CountryProvinceSelector($form.attr('id') + '-AddressCountry', $form.attr('id') + '-AddressProvince', { hideElement: $form.attr('id') + '-AddressProvinceContainer' });
      }

      // ------------------------------
      //  Methods
      // ------------------------------

      /**
       * Toggles between display of reset password and login screens.
       */

    }, {
      key: 'toggleResetScreen',
      value: function toggleResetScreen() {
        var $activeScreen = $(CLASSES.screen + ':not(.' + CLASSES.hiddenClass + ')');
        var $inactiveScreen = $('.' + CLASSES.hiddenClass + CLASSES.screen);

        $activeScreen.addClass(CLASSES.hiddenClass);
        $inactiveScreen.removeClass(CLASSES.hiddenClass);
      }
    }]);

    return Account;
  }();

  // Global export


  theme.account = new Account();
})(window.theme = window.theme || {}, jQuery);

/**
 * BLOG FILTERS
 *
 * @description Handles filtering logic of blog articles
 * @namespace theme.blogFilters
 */

(function (theme, $) {

  /**
   * Class representing blog filters.
   */
  var BlogFilters = function () {

    /**
     * Creates an instance of BlogFilters.
     *
     * @constructs BlogFilters
     */
    function BlogFilters() {
      _classCallCheck(this, BlogFilters);

      this._initializeHandlers();
    }

    _createClass(BlogFilters, [{
      key: '_initializeHandlers',
      value: function _initializeHandlers() {
        $(document).on('change', '#tagFilter', function () {
          location.href = $(this).val();
        });
      }
    }]);

    return BlogFilters;
  }();

  // Global export


  theme.blogFilters = new BlogFilters();
})(window.theme = window.theme || {}, jQuery);

/*
  Accordion Item

  Builds out an individual item that starts closed and slides down to open on click

  Basic HTML needed:

    <a href="#"class="js-accordion-item accordion-item">
      <span class="plus">{% include 'svg' with 'plus' %}</span>
      <span class="minus">{% include 'svg' with 'minus' %}</span>
      <h2>What are your payment options?</h2>
      <p class="accordion-item__content js-accordion-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sodales ante at enim vulputate pulvinar.</p>
    </a>

*/

/**
 *  ACCORDION ITEM
 * @description  Builds out an individual item that starts closed and slides down to open on click
 * @example
 *  $('.js-accordion-item').each(function() {new theme.AccordionItem(this);})
 *
 *  <a href="#"class="js-accordion-item accordion-item">
 *    <span class="plus">{% include 'svg' with 'plus' %}</span>
 *    <span class="minus">{% include 'svg' with 'minus' %}</span>
 *    <h2>What are your payment options?</h2>
 *    <p class="accordion-item__content js-accordion-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sodales ante at enim vulputate pulvinar.</p>
 *  </a>
 *
 */

(function (theme, $) {
  var AccordionItem =
  /**
   * @param {dom element} element - the element that contains the text elements
   */
  function AccordionItem(element) {
    var _this30 = this;

    _classCallCheck(this, AccordionItem);

    this.$element = $(element);
    this.$content = this.$element.find('.js-accordion-content');
    this.$trigger = this.$element.find('.js-accordion-trigger');
    this.$contentHeight = this.$content.outerHeight() + 20;
    this.$content.css('height', 0);

    this.$trigger.on('click keyup', function (e) {
      if (!event.keyCode || event.keyCode === 13) {
        e.preventDefault();

        if (_this30.$element.hasClass('is-active')) {
          _this30.$content.css('height', 0);
          _this30.$element.removeClass('is-active');
        } else {
          _this30.$content.css('height', _this30.$contentHeight);
          _this30.$element.addClass('is-active');
        }
      }
    });
  };

  function initialize() {
    theme.AccordionItem = AccordionItem;
  }

  $(function () {
    initialize();
  });
  // Section update
  $(document).on('shopify:section:load', function () {
    initialize();
  });
})(window.theme = window.theme || {}, window.jQuery);

// ------------------------------
// PARTIALS
// ------------------------------
(function ($, theme) {
  var SELECTORS = {
    hamburger: '.js-hamburger-menu',
    menu: '.js-menu',
    menu_item: '.js-menu-item',
    menu_wrapper: '.js-menu-wrapper',
    menu_overlay: '.js-menu-overlay',
    hero_full_screen: '.js-hero-full-screen'
  };

  var $body = $('body');
  var $html = $('html');
  var $header = $('.header');
  var $window = $(window);
  var window_width = $window.width();
  var $tab_elements = $(SELECTORS.menu_overlay).find('a, input, button, area[href], details, iframe, select, textarea');
  var $window_height = $window.height();
  var header_height = $header.outerHeight();
  var lastScrollTop = 0;

  // on page load, calculates the height of the header if hero banner needs full screen
  function calculateHeaderHeight() {
    $(SELECTORS.hero_full_screen).css('height', 'calc(' + $window_height + 'px - ' + header_height + 'px');
  }
  if ($(SELECTORS.hero_full_screen).length > 0) {
    calculateHeaderHeight();
  }

  // on page load, find all the tab-able elements in the header and set tabindex
  if (window_width >= theme.breakpoints.m) {
    $tab_elements.attr('tabindex', 0);
  }
  if (window_width < theme.breakpoints.m) {
    $tab_elements.attr('tabindex', -1);
  }

  // open the menu by clicking the hamburger
  $(SELECTORS.hamburger).click(function (e) {
    e.preventDefault();

    $(SELECTORS.menu).toggleClass('is-active');
    $(SELECTORS.menu_overlay).toggleClass('is-active');
    $(this).find('.js-close-icon, .js-hamburger-icon').toggleClass('hide');
    if ($(SELECTORS.menu).hasClass('is-active')) {
      $tab_elements.attr('tabindex', 0);
    } else {
      $tab_elements.attr('tabindex', -1);
    }
    $body.toggleClass('body--freeze', $(SELECTORS.menu_overlay).is('.is-active'));
    if ($(SELECTORS.menu_item).hasClass('is-active')) {
      $(SELECTORS.menu_item + '.is-active').trigger('click');
    }
  });

  // close the menu by clicking the overlay
  $(SELECTORS.menu_overlay).click(function (e) {
    if (window_width >= theme.breakpoints.m) {
      return;
    }

    var $chain = $(e.target).parents().addBack();
    var $this = $(this);

    if ($chain.is(SELECTORS.menu)) {
      return;
    }

    e.preventDefault();
    $tab_elements.attr('tabindex', -1);

    $(SELECTORS.menu).toggleClass('is-active');
    $this.toggleClass('is-active');
    $(SELECTORS.hamburger).find('.js-close-icon, .js-hamburger-icon').toggleClass('hide');
    $body.toggleClass('body--freeze', $this.is('.is-active'));
    if ($(SELECTORS.menu_item).hasClass('is-active')) {
      $(SELECTORS.menu_item + '.is-active').trigger('click');
    }
  });

  $(SELECTORS.menu_item).click(function (e) {
    var $chain = $(e.target).parents().addBack();
    var $this = $(this);
    if ($chain.is(SELECTORS.menu_wrapper)) {
      return;
    }

    if (window_width >= theme.breakpoints.m) {
      return;
    } else {
      e.preventDefault();

      $this.toggleClass('is-active').find('.js-item-open, .js-item-close').toggleClass('hide');
      if ($this.find(SELECTORS.menu_wrapper).hasClass('hide')) {
        $this.find(SELECTORS.menu_wrapper).slideDown({
          done: function done() {
            $this.find(SELECTORS.menu_wrapper).css('display', 'flex');
          }
        }).removeClass('hide');
      } else {
        $this.find(SELECTORS.menu_wrapper).slideUp().addClass('hide');
      }
    }
  });

  // Tabbing behaviour for menu. Unless clicking outside the item or using esc, focus out only occurs once that last tab-able element has been tabbed over
  $(SELECTORS.menu_item).on('focusin', 'a', function (e) {
    $(this).parent().addClass('has-focus-within');
  }).on('focusout', '.menu__nested-items .menu__item:last a', function (e) {
    $(this).parents().removeClass('has-focus-within');
  });

  // Makes sure that the previously opened top level menu item closes when tabbing backwards out of it
  $(SELECTORS.menu).keydown(function (e) {
    if (e.which === 9 && e.shiftKey === true) {
      var $this = $(e.target);
      if ($this.parent().hasClass('js-menu-item')) {
        $(SELECTORS.menu_item).removeClass('has-focus-within');
      }
    }
  });

  // Close tabbed menu item if hovering over another item
  $(SELECTORS.menu_item).hover(function (e) {
    if ($(SELECTORS.menu_item).hasClass('has-focus-within')) {
      $(SELECTORS.menu_item + '.has-focus-within').removeClass('has-focus-within');
      $tab_elements.blur();
    }
  });

  // Close menu by clicking out of it
  $(document).on('click', function (e) {
    var $chain = $(e.target).parents().addBack();
    if ($chain !== SELECTORS.menu_item && $('.js-menu-item').hasClass('has-focus-within')) {
      $(SELECTORS.menu_item).removeClass('has-focus-within');
    }
  });

  $window.resize($.debounce(250, function () {
    header_height = $header.outerHeight();
    $tab_elements.attr('tabindex', -1);

    if (window_width < theme.breakpoints.m && $window.width() >= theme.breakpoints.m) {
      window_width = $window.width();
      $(SELECTORS.menu_wrapper).slideUp().addClass('hide');
      $(SELECTORS.menu_overlay).removeClass('is-active');
      $body.removeClass('body--freeze');
      $(SELECTORS.menu).removeClass('is-active');
      $(SELECTORS.hamburger).find('.js-close-icon').addClass('hide');
      $(SELECTORS.hamburger).find('.js-hamburger-icon').removeClass('hide');
      $(SELECTORS.menu_item).removeClass('is-active has-focus-within');
      $(document.activeElement).blur();
      $(SELECTORS.menu_item).find('.js-item-open').removeClass('hide');
      $(SELECTORS.menu_item).find('.js-item-close').addClass('hide');
    }
    if ($window.width() >= theme.breakpoints.m) {
      $tab_elements.attr('tabindex', 0);
    }
    if ($window.width() < theme.breakpoints.m && !$(SELECTORS.menu).hasClass('is-active')) {
      $tab_elements.attr('tabindex', -1);
    }

    if (window_width >= theme.breakpoints.m && $window.width() < theme.breakpoints.m) {
      window_width = $window.width();
    }

    if ($(SELECTORS.hero_full_screen).size > 0) {
      calculateHeaderHeight();
    }
  }));

  $window.scroll($.debounce(10, function () {
    if (window_width >= theme.breakpoints.m) {
      if ($body.scrollTop() >= header_height || $html.scrollTop() >= header_height && !$header.is('.slide-down')) {

        if ($header.is('.has-announcement')) {
          $body.addClass('sticky-header--announcement');
        } else {
          $body.addClass('sticky-header');
        }

        $header.addClass('is-sticky').delay(1).queue(function (next) {
          $(this).addClass('slide-down');
          next();
        });
      }
    } else {
      var scrollTop = $window.scrollTop();

      if (scrollTop < lastScrollTop && scrollTop > 200 && !$header.is('.is-sticky')) {
        if ($header.is('.has-announcement')) {
          $body.addClass('sticky-header--announcement');
        } else {
          $body.addClass('sticky-header');
        }

        $header.addClass('is-sticky').delay(1).queue(function (next) {
          $(this).addClass('slide-down');
          next();
        });
      }

      lastScrollTop = scrollTop;
    }

    if ($body.scrollTop() == 0 && $html.scrollTop() == 0) {
      $header.removeClass('slide-down is-sticky');
      $body.removeClass('sticky-header sticky-header--announcement');
    }
  }));

  $(document).on('keydown', function (e) {
    if (e.keyCode === 27) {
      e.preventDefault();

      // Behaviour for escape/close on mobile which closes the whole menu instead of individual menu items
      if ($(SELECTORS.menu_overlay).hasClass('is-active')) {
        $tab_elements.attr('tabindex', -1);
      }
      if ($(SELECTORS.menu_item).hasClass('is-active')) {
        $(SELECTORS.menu_item + '.is-active').trigger('click');
      }

      // Behaviour on desktop which closes the individual menu items
      $(SELECTORS.menu_item).removeClass('has-focus-within');
      $(document.activeElement).blur();

      $(SELECTORS.menu).removeClass('is-active');
      $(SELECTORS.menu_overlay).removeClass('is-active');
      $(this).find('.header__menu-close').addClass('hide');
      $(this).find('.header__menu-hamburger').removeClass('hide');

      $body.removeClass('body--freeze');
    }
  });
})(jQuery, window.theme = window.theme || {});
(function (theme, $) {
  if ($('.js-product-tab').length < 1) {
    return;
  }

  function initialize() {
    var $tab_btns_underline = $('.js-product-tabs-underline');
    var $tabs = $('.js-product-tab');
    var $tab_desc = $('.js-product-tab-description');
    var $btns = $('.js-product-tab-btn');
    var current_window_width = $(window).width();
    // tabs are closed on mobile
    if ($(window).width() < theme.breakpoints.m) {
      $btns.removeClass('open-default is-active');
    }

    var initializeUnderlineAnimation = function initializeUnderlineAnimation() {
      var leftMargin = Number($btns.css('margin-left').split('p')[0]);
      var $active_btn = $('.js-product-tab-btn.is-active');
      var startingPoint = $active_btn.position().left + leftMargin + 'px';
      if ($(window).width() >= theme.breakpoints.m) {
        // sets the pink underline animation under the currently active tab, with the correct width and height
        $tab_btns_underline.css({
          top: $active_btn.outerHeight(),
          width: $active_btn.outerWidth(),
          left: startingPoint
        }).addClass('is-loaded');
      }
    };
    // gives page a moment to load everything up before grabbing position
    setTimeout(initializeUnderlineAnimation, 2000);

    $(window).resize($.debounce(250, function () {
      var new_window_width = $(window).width();
      // if now mobile
      if (new_window_width < window.theme.breakpoints.m && current_window_width >= window.theme.breakpoints.m) {
        $tab_btns_underline.removeClass('is-loaded');
        current_window_width = new_window_width;
        // if now desktop
      } else if (new_window_width >= window.theme.breakpoints.m && current_window_width < window.theme.breakpoints.m) {
        $btns.removeClass('open-default is-active');
        $btns.first().addClass('open-default is-active');
        initializeUnderlineAnimation();
        current_window_width = new_window_width;
      }
    }));

    // scroll down to yotpo reviews + open up reviews tab
    $('.product').on('click', '.yotpo.bottomLine', function (e) {

      e.preventDefault();
      var $target = $('.js-review-tab');
      $('html, body').stop().animate({
        scrollTop: $target.offset().top - 100
      }, 'slow');
      $target[0].click();
    });

    $btns.on('click', function () {
      var _this31 = this;

      var is_mobile = $(window).width() < theme.breakpoints.m;
      var $btn = $(this);
      var $tab = $btn.next('.js-product-tab');
      var $inactive_btns = $btns.not($btn);
      var $inactive_tabs = $tabs.not($tab);
      var delay = $inactive_btns.filter('.is-active').length > 0 ? 500 : 0;

      $inactive_tabs.slideUp(400);
      $inactive_btns.removeClass('is-active');

      if (is_mobile) {
        $btn.toggleClass('is-active');
        $tab.slideToggle(delay);
        setTimeout(function () {
          $('html, body').animate({
            scrollTop: $(_this31).first().offset().top - ($('.header__wrapper').outerHeight(true) + 12)
          }, 300);
        }, 500);
      } else {
        // CSS underline
        var leftMargin = Number($btns.css('margin-left').split('p')[0]);
        var leftPosition = $btn.position().left + leftMargin + 'px';
        $tab_btns_underline.css({
          left: leftPosition,
          width: $btn.outerWidth()
        });

        setTimeout(function () {
          $btn.addClass('is-active');
          $tab.slideDown(delay);
        }, delay);
      }
    });
  }

  // Document ready
  $(function () {
    initialize();
  });

  // Section update
  $(document).on('shopify:section:load', function () {
    initialize();
  });
})(window.theme = window.theme || {}, jQuery);
(function ($) {

  /**
   * Basic quantity selector logic.
   *
   * Uses input element's min an max attributes to determine where to stop.
   */
  function initialize() {
    $(document).on('click', '.js-qty-incr', function (e) {
      e.preventDefault();
      var $input = $(this).siblings('.js-qty-selector');
      $input.val(new Number($input.val()) + 1).trigger('change');
    });

    $(document).on('click', '.js-qty-decr', function (e) {
      e.preventDefault();
      var $input = $(this).siblings('.js-qty-selector');
      $input.val(new Number($input.val()) - 1).trigger('change');
    });

    $(document).on('change', '.js-qty-selector', function (e) {
      e.preventDefault();

      var $input = $(this);
      var val = new Number($input.val());
      var max = new Number($input.attr('max') || val + 1);

      $input.val(Math.max(0, Math.min(val, max)));

      // Lock + and - signs if at the limits
      $input.siblings('.js-qty-decr').prop('disabled', val <= 0);
      $input.siblings('.js-qty-incr').prop('disabled', val >= max);

      $input.trigger('Qty:change');
    });
  }

  // Document ready
  $(function () {
    initialize();
  });

  // Section update
  $(document).on('shopify:section:load', function () {
    initialize();
  });
})(window.jQuery);


(function ($, theme) {
  // Selectors in the DOM
  var SELECTORS = {
    original_variant_selector: '.js-original-variant-selector',
    form_dropdown: '.js-form-dropdown',
    form_colors: '.js-form-colors',
    selected_color: '.js-color-name',
    selected_size: '.js-dropdown-option-radio',
    option_selector: '.js-option-selector',
    option_label: '.js-option-label',
    product_price: '.js-product-price',
    wishlist: '.js-wishlist-cta',
    subscription_form: '.js-subscription-form',
    subscription_atc: '.js-subscription-atc',
    atc_labels: {
      add_to_cart: '.js-label-add_to_cart',
      atc_disabled: '.js-label-atc_disabled'
    }
  };

  var VariantSelectorForm = function () {
    function VariantSelectorForm($vs, product, isEdit) {
      var _this32 = this;

      _classCallCheck(this, VariantSelectorForm);

      this.$vs = $vs;
      this.$product = this.$vs.closest('.product');
      this.new_product = product;
      this.isModal = this.new_product.isQuickAdd || isEdit || false;
      this.last_recommendations = '';
      var seen_variants = new Set();
      var if_edit = $vs.hasClass("js-product-container-edit");
      if(if_edit) {
          var is_edit_form = ".js-product-container-edit "
        } else {
      	  var is_edit_form = ".js-product-container-custom "
        }

      if (product.product_type == 'Gift Card') {
        this.new_product.variants = [].concat(_toConsumableArray(this.new_product.variants), _toConsumableArray(product.variants)).filter(function (variant) {
          var duplicate = seen_variants.has(variant.id);
          seen_variants.add(variant.id);
          return !duplicate;
        });

        this.new_product.variants.forEach(function (variant) {
          _this32.$vs.find(SELECTORS.original_variant_selector).append('<option value="' + variant.id + '">' + variant.title + '</option>');
        });

        // Initialize variant selector
        this.selector = new theme.VariantSelector(this.$vs);
        this.checkPossibleVariants();
      } else {
        var ajax_calls = [];
        var color_options = this.new_product.options_with_values[0];
        var color_handles = window.color_handles[product.handle];

        // grab the images as associate them to a key that is the name of the color
        this.selectedColorValue = (color_options.selected_value || color_options.values[0]).handleize();

        this.new_product.images_by_color = {};
        this.new_product.images_by_color[this.selectedColorValue] = this.new_product.images.filter(function (img) {
          return img.alt != 'swatch';
        });
        
        color_handles.forEach(function (color) {
          ajax_calls.push($.get('/products/' + color + '?view=json', function (resp) {
            var response = JSON.parse(resp);
            // Includes duplicates
            _this32.new_product.variants = [].concat(_toConsumableArray(_this32.new_product.variants), _toConsumableArray(response.variants));
            var colorValue = response.options_with_values[0].values[0].handleize();
            _this32.new_product.images_by_color[colorValue] = response.images.filter(function (img) {
              return img.alt != 'swatch';
            });
          }));
        });


        $.when.apply(undefined, ajax_calls).then(function () {
          var colors = {};
          var colors_element = [];
          var selected_color = void 0, colors_by_tag = "";

          // Removes any duplicates from the array
          _this32.new_product.variants = _this32.new_product.variants.filter(function (variant) {
            var duplicate = seen_variants.has(variant.id);
            seen_variants.add(variant.id);
            return !duplicate;
          });

          // Generate the colour options
          _this32.new_product.variants.forEach(function (variant) {
            if (variant.option1_name == 'Color' && !colors[variant.option1]) {
              colors[variant.product_handle] = {
                swatch: variant.swatch,
                color: variant.option1
              };
            }
          });
          
          var selected_handle = _this32.new_product.handle;

          color_handles.forEach(function (handle, index) {
            var color_object = colors[handle];
            var filter_by_code, filter_by_color;

            if (color_object) {
              var color = color_object.color;
              var color_id = 'color--' + theme.utils.uniqueNumber(5) + (_this32.isEdit ? '--edit' : '');
              var color_handle = color.handleize();
              
              
              if (!selected_color) {
                selected_color = product.handle == handle ? color : '';
              }

              colors_element.push('\n                <div class="radio radio--color ' + product.handle + '" id="div' + color_id + '">\n                  <input type="radio" name="Color" title="' + color + '" value="' + color + '" class="form--product__option-selector js-option-selector js-color-option-value" id="' + color_id + '" data-color="' + color_handle + '" data-option="option1" ' + (product.handle == handle ? 'checked' : '') + '>\n                  <label for="' + color_id + '" title="' + color + '" tabindex="0" role="button">\n                    <span style="background-image: url(\'' + color_object.swatch + '\')">' + color + '</span>\n                  </label>\n                </div>\n              ');
            }

            _this32.$vs.on('change', '.js-color-option-value', function () {
              $('html, body').scrollTop($('.js-galleries').offset().top - $('.js-header.is-sticky').outerHeight());
            });
            //console.log(0,handle)
            
            //$(".color-tags." + handle).html("");
            // add product tag delv_code to colors
            $.getJSON('/products/' + handle + '.js', function (response) {
              var filter_color_type = "delv_code::";
              var filter_color = "color_group::";
              var delv, delv_value, delv_title, color_group, color_value, color_title, color_group_html;
              var product_tags = response.tags;

              function checkCode(str) {
                return str.startsWith(filter_color_type);
              }
              
              function checkColor(str) {
                return str.startsWith(filter_color);
              }

              //console.log(8,product_tags);
              filter_by_code = product_tags.find(checkCode);
              filter_by_color = product_tags.find(checkColor);
              delv = filter_by_code.substring(filter_color_type.length);
              color_group = filter_by_color.substring(filter_color.length);

              delv_value = "code--" + delv;
              delv_title = delv_value.substring("code--".length);
              color_value = "group--" + color_group;
              color_title = color_value.substring("color--".length);
              
              // add unique delv wrapper
              if($(is_edit_form + ".color-tags." + selected_handle).children("." + delv_value).length <= 0) {

                $(is_edit_form + ".color-tags." + selected_handle)
                .append("<div class='delv " + delv_value + " delv-" + selected_handle + "'><label class='label'>" + delv_title + "</label></div>");
              }
              
              $('#div' + color_id).attr('data-delv', delv_value);
              $('#div' + color_id).attr('data-color-group', color_value);
              
              if($(is_edit_form + ".color-tags." + selected_handle + " ." + delv_value).children("." + color_value).length <= 0) {
                color_group_html = "<span class='color-group " + color_value + " group-" + selected_handle + "' data-delv-parent='" + delv_value + "'></span>"
              } else {
                color_group_html = ""
              }
              // group by colors
              $(is_edit_form + ".delv." + delv_value + ".delv-" + selected_handle).append(color_group_html);
              
              $(is_edit_form + ".radio--color." + selected_handle).each(function() {
                var radio_delv = $(this).data("delv");
                var radio_group = $(this).data("color-group");
                var id = $(this).attr("id");
                
                $(is_edit_form + "." + radio_delv + ".delv-" + selected_handle + " ." + radio_group).append($(this));
              });

            });
            $(is_edit_form + '.js-form-colors.field-' + selected_handle).html("");
            $(is_edit_form + '.js-form-colors.field-' + selected_handle).html($(is_edit_form + ".color-tags." + selected_handle).html());

          });

          _this32.$vs.find(SELECTORS.form_colors).html(colors_element.join(''));

          // Update the list of color options with values
          _this32.new_product.options_with_values[0].values = Object.keys(colors).map(function (handle) {
            return colors[handle].color;
          });

          // Update the object once all calls are finished
          theme.products.update(_this32.new_product);

          // Injects variant IDs to the actual variant selector
          _this32.new_product.variants.forEach(function (variant) {
            _this32.$vs.find(SELECTORS.original_variant_selector).append('<option value="' + variant.id + '">' + variant.title + '</option>');
          });

          // Initialize variant selector
          _this32.selector = new theme.VariantSelector(_this32.$vs);

          _this32.$vs.find('[name="Color"]').click(function (e) {
            _this32.$vs.find(SELECTORS.selected_color).text($(e.target).next().attr('title'));
          });

          // Set the initial selected color
          _this32.$vs.find(SELECTORS.selected_color).text(selected_color);

          _this32.buildProductGalleries();
          _this32.checkPossibleVariants();

          _this32.$vs.on('VariantSelector:selected:Color', function (event, value) {
            return _this32.updateProductGallery(value);
          });
        });
      }

      this.$vs.on('VariantSelector:selectionComplete', function () {

        // Safeguard to re-pop the label when you return to the page by clicking back, because the checked inputs are remembered but the dropdown label doesn't display it.
        var selected_size = _this32.$vs.find(SELECTORS.selected_size).filter(':checked').val();
        if (selected_size) {
          _this32.$vs.find('.js-product-field-size .js-dropdown-label').text(selected_size);
        }
        _this32.$vs.find(SELECTORS.atc_labels.add_to_cart).removeClass('hide');
        _this32.$vs.find(SELECTORS.atc_labels.atc_disabled).addClass('hide').closest('button').prop('disabled', false);
        // when a variant is chosen, enable wishlist button
        _this32.$vs.next('.js-wishlist-tile').find(SELECTORS.wishlist).prop('disabled', false);
      });

      this.$vs.on('VariantSelector:selectionUpdated', function (event, variants) {
        var variant = variants[0];
        if (variant && variant.url) {
          var variant_url = variant.url.split('?')[0];
          window.history.replaceState({}, '', variant_url);
          _this32.updateRecommendations(variant_url);
        }
      });

      /*
        Handle subscription add to cart
      */
      if (document.querySelector(SELECTORS.subscription_form)) {
        this.$vs.on('VariantSelector:selectionIncomplete', function () {
          _this32.$vs.find(SELECTORS.subscription_atc).prop('disabled', true);
        });

        this.$vs.on('VariantSelector:selectionComplete', function () {
          _this32.$vs.find(SELECTORS.subscription_atc).prop('disabled', false);
        });
      }
    }

    _createClass(VariantSelectorForm, [{
      key: 'buildProductGalleries',
      value: function buildProductGalleries() {
        var _this33 = this;

        var navClass = this.isModal ? '' : 'js-scroll';
        var productGalleries = Object.entries(this.new_product.images_by_color).map(function (entry) {
          var colorValue = entry[0];
          var image_list = entry[1];

          var $slider = $('<div ' + (image_list.length > 1 ? 'class="js-slideshow product__images-slideshow"' : '') + '></div>');
          var slideshow_settings = {
            "arrows": true,
            "swipeToSlide": true,
            "slidesToShow": 1,
            "slidesToScroll": 1,
            "infinite": true,
            "responsive": [{
              "breakpoint": 640,
              "settings": "unslick"
            }]
          };
          $slider.data('slick', JSON.stringify(slideshow_settings));

          var $scrollWrap = $('<div class="product__image-buttons-wrap ' + (image_list.length < 2 ? 'invisible' : '') + '"></div>');
          var $scrollButtons = $('<ul class="product__image-buttons js-image-buttons"></ul>');

          image_list.forEach(function (image, index) {
            var imageId = 'image--' + theme.utils.uniqueNumber(5) + '--' + image.id + (_this33.isEdit ? '--edit' : '');
            $slider.append('\n            <div class="responsive-image__wrapper js-product-image product__image ' + (index == 0 ? 'is-active' : '') + '" data-zoom="' + image.src + '">\n                <img\n                  id="' + imageId + '"\n                  class="responsive-image__image ' + (_this33.isModal ? 'is-loaded' : 'lazyload') + '"\n                  data-src="' + theme.utils.getSizedImageUrl(image.src, '{width}x') + '"\n                  data-widths="[360,540,720,900,1080,1440,2160,3240]"\n                  data-sizes="auto"\n                  data-aspectratio="' + image.aspect_ratio + '"\n                  alt="' + image.alt + '"\n                  tabindex="-1"\n                  style="position: static"\n                  ' + (_this33.isModal ? 'src="' + image.src + '"' : '') + '\n                >\n            </div>\n          ');
            $scrollButtons.append('\n            <li>\n              <a href="#' + imageId + '" data-id="' + imageId + '" data-scroll-speed="fast" class="' + (index == 0 ? 'is-current' : '') + ' product__image-button js-product-image-button ' + navClass + '">' + image.alt + '</a>\n            </li>\n          ');
          });

          $scrollWrap.append($scrollButtons);

          return $('<div class="product__images" data-selected-color="' + colorValue + '"></div>').append($slider).append($scrollWrap);
        });

        this.$product.find('.js-galleries').empty().append(productGalleries);
        theme.reinitializeSliders();
        this.updateProductGallery(this.selectedColorValue, true);

        /**
         * this is definitely a bandaid. is-initialized gets added by scroll-to.js, which is listening for gallery:load
         * quickadd image gallery scroll behaves differently because it's within a container, so it we need the check for this.isModal
         * buut without the check for is-initialized, when quick add gets initialized, this would reinitilize all the dots including
         * the regular gallery, and this.isModal would be set to true
         * TODO: make better
         */

        document.querySelectorAll('.js-product-image-button').forEach(function (element) {
          if (!element.classList.contains('is-initialized')) {
            new theme.Dot(element, _this33.isModal);
          }
        });

        $(document).trigger('gallery:load');
        // keeping this here even though it's also in carousel.js because without it we get an ADA error
        $('.js-slideshow.product__images-slideshow').on('setPosition', function (slick) {
          var $activeSlide = $([].concat(_toConsumableArray(slick.currentTarget.children))).filter('.js-product-image.is-active')[0];
          if ($activeSlide !== undefined) {
            var tabIndex = $activeSlide.getAttribute('tabindex');
            var ariaHidden = $activeSlide.getAttribute('aria-hidden');
            if (tabIndex === "0" && ariaHidden === "true") {
              $activeSlide.setAttribute('aria-hidden', "false");
            }
          }
        });
      }
    }, {
      key: 'updateRecommendations',
      value: function updateRecommendations(url) {
        if (url != this.last_recommendations) {
          this.last_recommendations = url;

          var loadSliders = function loadSliders() {
            theme.reinitializeSliders();
            $('.js-product-complete, .js-product-related').find('.js-tile-swatch:checked').trigger('change');
          };

          $('.js-product-complete').load(url + '?section_id=product__complete', loadSliders);
          $('.js-product-related').load(url + '?section_id=product__related', loadSliders);
        }
      }
    }, {
      key: 'updateProductGallery',
      value: function updateProductGallery(colorValue, onLoad) {
        var colorValueHandle = colorValue.handleize();
        if (colorValueHandle != this.selectedColorValue || onLoad == true) {
          this.$product.find('[data-selected-color]').removeClass('is-active');
          this.$product.find('[data-selected-color=' + colorValueHandle + ']').addClass('is-active');
          this.selectedColorValue = colorValueHandle;
          this.$product.find('.js-slideshow.slick-initialized').slick('setPosition');
          if ($('.slick-initialized .js-product-image.is-active').length) {
            $([document.documentElement, document.body]).animate({
              scrollTop: $('.slick-initialized .js-product-image.is-active').offset().top
            }, 500);
          }
        }
      }
    }, {
      key: 'checkPossibleVariants',
      value: function checkPossibleVariants() {
        var vs = this.selector;
        var that = this;

        var available_colors = [];

        function updatePossibleVariants() {
          var possible_variants = vs.variant_selector._possible_variants;

          Object.keys(vs.variant_selector.filtered_options).forEach(function (option_name) {
            var options = vs.variant_selector.filtered_options[option_name];

            that.$vs.find('.js-option-selector[name="' + option_name + '"]').each(function () {
              var $input = $(this);
              var value = $input.val();
              var option_key = $input.data('option');

              if (options.reduce(function (acc, variant) {
                return acc || variant[option_key] == value;
              }, false)) {
                $input.prop('disabled', false).removeClass('is-unavailable').closest('.radio').find('label').prop('tabindex', 0);
              } else {
                $input.prop('disabled', true).addClass('is-unavailable').closest('.radio').find('label').prop('tabindex', -1);
              }
            });
          });

          if (possible_variants.length == 1) {
            var price = theme.utils.toMoney(possible_variants[0].price, {
              cents: true,
              no_zeros: true
            });
            that.$vs.find(SELECTORS.product_price).text(price);
          }
        }

        // TODO: Check if loops can be merged
        Object.keys(vs.variant_selector.filtered_options).forEach(function (option_name) {
          var options = vs.variant_selector.filtered_options[option_name];

          if (option_name == 'Color') {
            options.forEach(function (option) {
              if (available_colors.indexOf(option.option1) < 0) {
                available_colors.push(option.option1);
              }
            });
          }
        });

        that.$vs.find('.js-option-selector[name="Color"]').each(function () {
          if (available_colors.indexOf($(this).val()) < 0) {
            $(this).closest('.radio').addClass('is-unavailable');
          }
        });

        updatePossibleVariants();

        this.$vs.on('VariantSelector:selectionUpdated', updatePossibleVariants.bind(this));
      }
    }]);

    return VariantSelectorForm;
  }();

  theme.VariantSelectorForm = VariantSelectorForm;

  // Initialize initial product page form
  window.variantSelectorForms = [];

  if (theme.template.name == 'product') {
    // Find the product in the array and store it as a variable
    var new_product = theme.products.list[theme.product.handle];
    variantSelectorForms.push(new VariantSelectorForm($('.product__form .js-product-container-custom'), new_product));
  }
})(jQuery, window.theme = window.theme || {});

(function ($, theme) {
  function initialize() {
    var $cart = $('.cart');
    var CLASSES = {
      container: '.js-cart-form-container'
    };
    var cart_lock = false;

    function lockCart() {
      cart_lock = true;
      $cart.addClass('is-loading');
      $('.js-atc-button').prop('disabled', true);
    }

    function unlockCart() {
      cart_lock = false;
      $cart.removeClass('is-loading');
      $('.js-atc-button').prop('disabled', false);
    }

    function refreshForm() {
      lockCart();

      $.get('/cart?view=ajax', function (r) {
        $(CLASSES.container).html(r);
        unlockCart();
        $(document).trigger('AjaxCart:set');

        if ($('.cart__items').length) {
          $('.js-cart-icon').addClass('has-contents');
        } else {
          $('.js-cart-icon').removeClass('has-contents');
        }
      });
    }

    function refreshRecommendations() {
      if (theme.template.name != 'cart') {
        var _$recs = $('.js-cart-recommendations');

        $.get('?section_id=cart__recommendations', function (response) {
          if ($(response).children().length == 0) {
            _$recs.empty().hide();
          } else {
            _$recs.html(response).show();
            theme.reinitializeSliders();
            $('.js-tile-swatch:checked').trigger('change');
          }
        });
      } else {
        $recs.empty().hide();
      }
    }

    function calculatePromotions() {
      var exploded_items = [];
      lockCart();

      theme.cart.content.items.forEach(function (item, index) {
        for (var i = 0; i < item.quantity; i++) {
          var individual_item = {
            quantity: 1,
            id: item.id,
            original_price: item.original_price,
            properties: item.properties,
            order: index
          };
          individual_item.properties._bundle_id = '';
          individual_item.properties._set_id = '';
          individual_item.properties._set_top = '';

          exploded_items.push($.extend(true, {}, individual_item));
        }
      });

      // Sort items by highest price
      exploded_items = exploded_items.sort(function (a, b) {
        return b.original_price - a.original_price;
      });

      // Main function for iterating through items and their props to group a matching tag in lip
      Array.prototype.groupBy = function (prop) {
        return this.reduce(function (groups, item) {
          var val = item.properties[prop];
          groups[val] = groups[val] || [];
          groups[val].push(item);
          return groups;
        }, {});
      };

      // Group by bundle value if prop exists. Ex: all bundle:82, all bundle:74
      var bundle_items = exploded_items.filter(function (item) {
        return item.properties._BUNDLE != undefined && !item.properties._SALE;
      });
      var groupByBundle = bundle_items.groupBy('_BUNDLE');

      Object.entries(groupByBundle).forEach(function (_ref9) {
        var _ref10 = _slicedToArray(_ref9, 2),
            key = _ref10[0],
            value = _ref10[1];

        var remaining = value.length - value.length % 3;

        value.forEach(function (item, index) {
          var bundle_id = 'bundle_' + Math.floor(index / 3);
          item.properties._bundle_id = remaining > 0 ? bundle_id : '';
          remaining = Math.max(0, remaining - 1);
        });
      });

      // Group by set value if prop exists
      var set_items = exploded_items.filter(function (item) {
        return item.properties._SET != undefined && !item.properties._bundle_id && !item.properties._SALE;
      });
      var groupBySet = set_items.groupBy('_SET');

      Object.entries(groupBySet).forEach(function (_ref11) {
        var _ref12 = _slicedToArray(_ref11, 2),
            key = _ref12[0],
            value = _ref12[1];

        var groupByCode = value.groupBy('_group_code');

        Object.entries(groupByCode).forEach(function (_ref13) {
          var _ref14 = _slicedToArray(_ref13, 2),
              key = _ref14[0],
              value = _ref14[1];

          var buy = value.filter(function (item) {
            return !item.properties._set_discounted;
          });
          var get = value.filter(function (item) {
            return item.properties._set_discounted;
          });
          var remaining = buy.length;
          var set_amount = Math.min(get.length, remaining);

          for (var i = 0; i < buy.length; i++) {
            buy[i].properties._set_top = i < set_amount ? 'set_' + i : '';
          }

          for (var _i = 0; _i < get.length; _i++) {
            get[_i].properties._set_id = _i < set_amount ? 'set_' + _i : '';
          }
        });
      });

      // Combine identical objects or increment the quantity
      var regrouped_items = {};
      exploded_items.forEach(function (item) {
        var key = '' + item.id + item.properties._set_id + item.properties._bundle_id;

        if (regrouped_items[key]) {
          regrouped_items[key].quantity++;
        } else {
          regrouped_items[key] = item;
        }
      });
      regrouped_items = Object.values(regrouped_items);

      // Clear the cart and re-submit the items
      var queue = $.ajax({
        url: '/cart/clear.json',
        type: 'POST',
        dataType: 'json'
      });

      if (regrouped_items.length) {
        queue = queue.then(function () {
          return $.ajax({
            url: '/cart/add.json',
            type: 'POST',
            dataType: 'json',
            data: { items: regrouped_items }
          });
        });
      }

      queue.always(function () {
        refreshForm();
      });
    }

    $(document).on('Qty:change', function (e) {
      e.preventDefault();

      if (!cart_lock) {
        lockCart();

        var $input = $(e.target);
        var data = {
          id: $input.data('key'),
          quantity: parseInt($input.val())
        };

        theme.cart.update(data);
      }
    });

    $(document).on('click', '.line-item__remove', function (e) {
      e.preventDefault();
      if (!cart_lock) {
        lockCart();

        theme.cart.remove($(this).data('key'));
      }
    });

    $(document).on('Cart:set', function () {
      calculatePromotions();
    });

    // Need to resize the slider for it to re-calculate when the fly-out opens
    $(document).on('Flyout:open', '.js-flyout.cart--flyout', function () {
      refreshRecommendations();
      var focusable = 'input:visible, button:visible, a:visible, [tabindex]:visible, [role="button"]:visible';
      $('.js-flyout.cart--flyout').find(focusable).first().focus();
    });

    $('#cart-note-submit').on('click', function (e) {
      e.preventDefault();
      var checkout_btn = $('button[name="checkout"]');
      var new_note = $('textarea[name="note"]').val();
      checkout_btn.prop('disabled', true);

      $.ajax({
        url: '/cart/update.json',
        type: 'POST',
        dataType: 'json',
        data: { note: new_note }
      }).then(function () {
        checkout_btn.prop('disabled', false);
      });
    });
  }

  // Document ready
  $(function () {
    initialize();
  });

  // Section update
  $(document).on('shopify:section:load', function () {
    initialize();
  });
})(window.jQuery, window.theme);

(function ($, cart) {
  function initialize() {
    $(document).on('click.atc', '.js-atc-button', function (e) {
      var _this34 = this;

      e.preventDefault();
      // Disable the atc so no spam clicking can occur. It will be re-enabled post cart set/on cart refresh. 
      $(this).prop('disabled', true);
      var $form = $(this).closest('form');
      var $modal = $(this).closest('.js-modal-container');

      //
      /*theme.cart.add(theme.utils.toObject($form.serialize())).then(function () {
        $('[data-flyout-toggle="cart-flyout"]').first().click();
        if ($modal.length) {
          $modal.find('[data-modal-close]').trigger('click');
        }
      }).fail(function () {
        $(_this34).prop('disabled', false);
        $form.off('submit.atc').submit();
        if ($modal.length) {
          $modal.find('[data-modal-close]').trigger('click');
        }
      });*/
    });
  }

  // Document ready
  $(function () {
    initialize();
  });

  // Section update
  $(document).on('shopify:section:load', function () {
    initialize();
  });
})(window.jQuery, window.theme);

(function ($, _ref15) {
  var cart = _ref15.cart;

  function initialize() {
    $(document).on('submit.subscription', '.js-subscription-form', function (e) {
      e.preventDefault();
      var $productForm = $(this).siblings('[action="/cart/add"]');
      var $subscriptionForm = $(this);
      var $modal = $(this).closest('.js-modal-container');
      cart.add(theme.utils.toObject($productForm.serialize() + '&' + $subscriptionForm.serialize())).then(function (resp) {

        $('[data-flyout-toggle="cart-flyout"]').first().click();
        if ($modal.length) {
          $modal.find('[data-modal-close]').trigger('click');
        }
      }).fail(function () {
        $subscriptionForm.off('submit.subscription').submit();
        if ($modal.length) {
          $modal.find('[data-modal-close]').trigger('click');
        }
      });
    });
  }

  // Document ready
  $(function () {
    initialize();
  });

  // Section update
  $(document).on('shopify:section:load', function () {
    initialize();
  });
})(window.jQuery, window.theme);

/*
	Script to initialize all sliders.
*/
(function (theme, $) {

  var DEFAULT_SETTINGS = {
    dots: false,
    mobileFirst: true,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev slick-arrow">' + theme.svgs.chevron.left + '<span class="sr-only">Previous</span></button>',
    nextArrow: '<button type="button" class="slick-next slick-arrow">' + theme.svgs.chevron.right + '<span class="sr-only">Next</span></button>',
    customPaging: function customPaging(slider, i) {
      return '\n              <button class="js-slider-dot">\n                <span class="u-link-title">Go to slide ' + (i + 1) + '</span>\n              </button>\n            ';
    }
  };

  var Slider = function () {
    function Slider($slider) {
      var _this35 = this;

      var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _classCallCheck(this, Slider);

      this.elements = {
        slider: $slider,
        window: $(window)
      };
      this.settings = Object.assign({}, DEFAULT_SETTINGS, settings);

      this.slick();

      this.elements.window.on('resize', $.debounce(250, function () {
        _this35.slick();
      }));
    }

    _createClass(Slider, [{
      key: 'slick',
      value: function slick() {
        if (!this.elements.slider.hasClass('slick-initialized')) {
          this.elements.slider.slick(this.settings);
        }
      }
    }]);

    return Slider;
  }();

  function initialize() {
    $('.js-slideshow').on('setPosition', function (slick) {
      var $activeSlide = $([].concat(_toConsumableArray(slick.currentTarget.children))).filter('.slick-slide.slick-active')[0];
      if ($activeSlide !== undefined) {
        var tabIndex = $activeSlide.getAttribute('tabindex');
        var ariaHidden = $activeSlide.getAttribute('aria-hidden');
        if (tabIndex === "0" && ariaHidden === "true") {
          $activeSlide.setAttribute('aria-hidden', "false");
        }
      }
    }).each(function () {
      var $slider = $(this);

      if ($slider.children().length) {
        var settings = JSON.parse($slider.data('slick')) || {};
        new Slider($slider, settings);
      }
    });
  }

  theme.reinitializeSliders = initialize;

  $(function () {
    initialize();
  });

  /*
      Re-initializes all sliders on the view after changes have been
      made to the theme settings.
  */
  $(document).on('shopify:section:load', function () {
    initialize();
  });
})(window.theme = window.theme || {}, jQuery);

/*
  Script to handle country toggle and by extension, language toggle & currency
*/
(function (theme, $) {
  theme.domains = {
    na: {
      url: 'cosabella-north-america.myshopify.com',
      defaults: {
        currency: 'USD',
        lang: 'en-cos',
        country: 'us'
      }
    },
    int: {
      url: 'cosabella-international.myshopify.com',
      defaults: {
        currency: 'EUR',
        lang: 'en-cos',
        country: 'eu'
      }
    }
  };

  theme.local_map = {
    'us': {
      locale: 'en-cos',
      currency: 'USD',
      domain: theme.domains.na.url
    },
    'mx': {
      locale: 'es-cos',
      currency: 'USD',
      domain: theme.domains.na.url
    },
    'ca': {
      locale: 'en-cos',
      currency: 'CAD',
      domain: theme.domains.na.url
    },
    'uk': {
      locale: 'en-cos',
      currency: 'GBP',
      domain: theme.domains.int.url
    },
    'it': {
      locale: 'it-cos',
      currency: 'EUR',
      domain: theme.domains.int.url
    },
    'fr': {
      locale: 'fr-cos',
      currency: 'EUR',
      domain: theme.domains.int.url
    },
    'de': {
      locale: 'de-cos',
      currency: 'EUR',
      domain: theme.domains.int.url
    },
    'es': {
      locale: 'es-cos',
      currency: 'EUR',
      domain: theme.domains.int.url
    },
    'eu': {
      locale: 'en-cos',
      currency: 'EUR',
      domain: theme.domains.int.url
    },
    'int': {
      locale: 'en-cos',
      currency: 'EUR',
      domain: theme.domains.int.url
    },
    'au': {
      locale: 'en-cos',
      currency: 'AUD',
      domain: theme.domains.int.url
    }
  };

  var CountryManager = function () {
    function CountryManager() {
      _classCallCheck(this, CountryManager);

      this.queue = $.when();
      this.elements = {
        body: $('body'),
        countries: $('.js-country-toggle .js-dropdown-option-radio')
      };

      this.store = Object.keys(theme.domains).map(function (domain) {
        return theme.domains[domain];
      }).filter(function (domain) {
        return domain.url == theme.shop.permanent_domain;
      })[0];

      this._country = theme.cart.content.attributes._country || this.store.defaults.country;
      this._currency = window.Shopify.currency.active;
      this._lang = theme.multilingual.current.locale || this.store.defaults.country;
      this.country_settings = theme.local_map[this.country];

      this.readParams();
      this.bindEvents();
    }

    _createClass(CountryManager, [{
      key: 'readParams',
      value: function readParams() {
        var params = theme.utils.getURLParams();

        if (params.country) {
          this.country = params.country;
        }
      }
    }, {
      key: 'bindEvents',
      value: function bindEvents() {
        var _this36 = this;

        // Toggle country function
        this.elements.countries.on('change', function (e) {
          _this36.country = $(e.target).data('country');
        });
      }
    }, {
      key: 'redirect',
      value: function redirect(lang) {
        // Grabs the path supplied by ml__toggle/the metafields so that we're always on the correct page/product/collection/ etc.
        var redirect_path = $('input[data-locale=' + lang + ']').data('href');

        // Grab the query parameters if they exist to manipulate the country query
        var query_string = '';
        var params_length = 0;

        if (window.location.href.indexOf('?') > -1) {
          var search_params = new URLSearchParams(window.location.search);

          // If you happen to switch again post store switch, we want to delete the country param
          var country = search_params.get('country');
          if (country) {
            search_params.delete('country');
          }
          params_length = Array.from(search_params).length;
          query_string = params_length > 0 ? '?' + search_params : '';
        }

        var url = window.location.protocol + '//' + this.country_settings.domain + (redirect_path || window.location.pathname) + query_string;

        if (this.country_settings.domain != theme.shop.permanent_domain) {
          url = '' + url + (params_length == 0 ? '?' : '&') + 'country=' + this.country;
        }

        window.location.href = url;
      }
    }, {
      key: 'currency',
      set: function set(currency) {
        if (currency && currency != this._currency) {
          this._currency = currency;
          var options = {
            form_type: 'currency',
            currency: this._currency
          };
          this.queue = this.queue.then(function () {
            return $.post('/cart/update', options);
          });
        }
      },
      get: function get() {
        return this._currency;
      }
    }, {
      key: 'country',
      set: function set(country) {
        var _this37 = this;

        var country_settings = theme.local_map[country];
        var param_currency = country_settings.currency;
        var lang = this._lang;

        // Check if we need to make a currency or language switch
        var currency_switch = param_currency !== this._currency ? true : false;
        var lang_switch = lang !== country_settings.locale ? true : false;

        if (country && country !== this._country || !theme.cart.content.attributes._country && currency_switch || lang_switch) {

          if (country_settings) {
            if (currency_switch || lang_switch) {
              this.elements.body.addClass('loader is-loading');
            }
            this._country = country;
            this.country_settings = country_settings;

            if (this.country_settings.domain == theme.shop.permanent_domain) {
              var attributes = {
                _country: country,
                _locale: this.country_settings.locale
              };

              // Changing the country changes currency and language as well
              this.currency = this.country_settings.currency;
              if (lang_switch) {
                attributes._locale = this.country_settings.locale;
                lang = attributes._locale;
              }

              // Only reload the page if currency or language has been changed. If not, pass a silent cart attribute update only
              this.queue = this.queue.then(function () {
                return theme.cart.updateAttributes(attributes, { silent: true });
              }).then(function () {
                if (currency_switch || lang_switch) {
                  _this37.redirect(lang);
                }
              });
            } else {
              this.redirect(this.country_settings.locale);
            }
          }
        } else if (!theme.cart.content.attributes._country && !currency_switch && !lang_switch) {
          // Set the attribute if nothing else changes
          var _attributes = {
            _country: country
          };
          this.queue = this.queue.then(function () {
            return theme.cart.updateAttributes(_attributes, { silent: true });
          });
        }
      },
      get: function get() {
        return this._country;
      }
    }]);

    return CountryManager;
  }();

  $(function () {
    theme.countryManager = new CountryManager();
  });

  $(document).on('shopify:section:load', function () {
    theme.countryManager = new CountryManager();
  });
})(window.theme = window.theme || {}, jQuery);

/**
 * Scroll to specific element via anchor tag click
 *
 *
 * @example
 * <a href="#targetElementId" class="js-scroll" data-scroll-speed="fast">This is where I am</a>
 * <section id="targetElementId">This is where I want to go</section>
 */

(function () {
  function initialize() {
    function scrollToTarget(e) {
      e.preventDefault();
      var $trigger = $(e.target);
      var $target = $('' + $trigger[0].hash);
      var scrollSpeed = e.target.dataset.scrollSpeed || 'slow';
      var focusable = 'input:visible, button:visible, a:visible, [tabindex]:visible, [role="button"]:visible';

      $('html, body').stop().animate({
        scrollTop: $target.offset().top - 100
      }, {
        done: function done() {
          $target.find(focusable).first().focus();
        }
      }, scrollSpeed);
    }

    var linksToAnchors = document.querySelectorAll('.js-scroll');

    linksToAnchors.forEach(function (each) {
      if (each.classList.contains('is-initialized')) {
        return;
      } else {
        each.classList.add('is-initialized');
        return each.onclick = scrollToTarget;
      }
    });
  }
  // Document ready
  $(function () {
    initialize();
  });

  // Section update
  $(document).on('shopify:section:load gallery:load', function () {
    initialize();
  });
})();

(function ($, theme) {

  /**
   * Changes the colors of the nav dots on the product image gallery
   *
   * Intersection Observer is a new-ish native API that tracks when an element comes into view
   * For more info: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
   * A proxy file exists in node_modules & uploaded in vendors for any browsers (ios safari) that don't have it already attached to the window object
   */
  var Dot = function () {
    function Dot(element, isModal) {
      _classCallCheck(this, Dot);

      /**
       * Creates a dot instance uses intersection observer to detect when its corresponding image is in the viewport, and then adds the active class to the dot (an anchor tag)
       *
       * @param {DOM element} [element] - The element that is the dot, should be an anchor tag, and needs to have the image id as its href
       * @param {bolean} [isModal] - check if the dot is in a modal (quick-add or edit) gallery for different scroll behaviour
       */
      this.element = element;
      // all the dots have the image id as their href, so using that to get the image target
      this.target = $('' + this.element.hash)[0];
      this.isModal = isModal;
      this.config = {
        // If the image gets within 50% in the Y axis
        rootMargin: '-50% 0px',
        threshold: 0
      };

      this.$productDots = $(this.element).closest('.js-image-buttons').find('.js-product-image-button');

      if (this.isModal) {
        this.element.onclick = this.scrollToTarget;
      }

      var dot = this;

      if ($(window).width() < theme.breakpoints.m) {
        this.event = 'click';
        this.magnify = '0.4';
      } else {
        this.event = 'mouseover';
        this.magnify = '1';
      }

      $(this.target).parent().zoom({
        url: $(this.target).parent().attr('data-zoom'),
        on: this.event,
        magnify: this.magnify,
        callback: function callback() {
          try {
            var observer = new IntersectionObserver(dot.onIntersection.bind(dot), dot.config);
            observer.observe(dot.target);
            $(dot.element).css({
              'display': 'inline-block'
            });
          } catch (error) {
            console.warn('Image Gallery: Intersection observers not supported');
          }
        }
      });
    }

    // handles the click-to-scroll on quick add, that would otherwise be handled by scroll-to.js


    _createClass(Dot, [{
      key: 'scrollToTarget',
      value: function scrollToTarget(e) {
        e.preventDefault();
        var $trigger = $(e.target);
        var $target = $('' + $trigger[0].hash);
        var $container = $target.closest('.js-slideshow');
        $container.stop().animate({
          scrollTop: $container.scrollTop() + ($target.offset().top - $container.offset().top)
        }, 'slow');
      }
    }, {
      key: 'onIntersection',
      value: function onIntersection(e) {
        var entry = e[0];
        if (entry.isIntersecting) {
          var id = entry.target.id;
          if (this.element.dataset.id == id) {
            this.$productDots.removeClass('is-current');
            this.element.classList.add('is-current');
          }
        }
      }
    }]);

    return Dot;
  }();

  theme.Dot = Dot;
})(jQuery, window.theme = window.theme || {});
(function ($, theme) {
  function initialize() {

    var rendered_tiles = {};

    /**
     * Render a tiles html string to the DOM.
     *
     * @param {string} html
     */
    function renderQuickAdd(html) {
      $('#quick-add-modal .js-modal-container').html(html);
    }

    function openQuickAddModal(modal_id) {
      var quick_add_modal = new theme.Modal(modal_id);

      quick_add_modal.show();
      $(quick_add_modal.modal).find('.modal__close').first().focus();
    }

    function initQuickAddVariantSelector(product) {
      product.isQuickAdd = true;
      window.variantSelectorForms.push(new theme.VariantSelectorForm($('#quick-add-modal .js-product-container-custom'), product));
    }

    function initDropdowns() {
      document.querySelector('#quick-add-modal .js-modal-container').querySelectorAll('.js-dropdown-wrapper').forEach(function (wrapper) {
        new theme.RadioDropdown({ wrapper: wrapper });
      });
    }

    $(document).on('change', '.js-tile-swatch', function () {
      var $input = $(this);
      var $tile = $input.closest('.product-tile');

      // Update the image
      var image_url = $input.data('image');
      var image_hover_url = $input.data('image-hover');
      var $image = $tile.find('.product-tile__image > .responsive-image__image');
      var $image_hover = $tile.find('.product-tile__image--hover > .responsive-image__image');

      if ($image.length && image_url) {
        $image.attr('data-src', theme.utils.getSizedImageUrl(image_url, '{width}x'));
      }

      if ($image_hover.length && image_hover_url) {
        $image_hover.attr('data-src', theme.utils.getSizedImageUrl(image_hover_url, '{width}x'));
        $tile.find('.product-tile__image-link').addClass('has-hover-image');
      } else {
        $tile.find('.product-tile__image-link').removeClass('has-hover-image');
      }

      // Update the links
      var url = $input.data('url');
      var $links = $tile.find('a');

      if ($links.length && url) {
        $links.attr('href', url);
      }
    });

    /**
     * On opening of a quick-add modal,
     * retrieve the product quick view html via AJAX.
     */
    $(document).on('click', '.js-open-quick-add', function (e) {
      e.preventDefault();

      var handle = $(this).data('product-handle');
      var modal_id = $(this).data('modal-target');

      if (rendered_tiles[handle]) {
        renderQuickAdd(rendered_tiles[handle]);
        initQuickAddVariantSelector(theme.products._list[handle]);
        initDropdowns();
        openQuickAddModal(modal_id);
      } else {
        $.get('/products/' + handle + '?view=quick-add-ajax').then(function (d) {
          rendered_tiles[handle] = d;
          renderQuickAdd(d);
          initQuickAddVariantSelector(theme.products._list[handle]);
          initDropdowns();
          openQuickAddModal(modal_id);
        });
      }
    });

    $('.js-tile-swatch:checked').trigger('change');
  }

  // Document ready
  $(function () {
    initialize();
  });

  // Section update
  $(document).on('shopify:section:load', function () {
    initialize();
  });
})(window.jQuery, window.theme || {});

(function ($) {
  function initialize() {
    $(document).on('click', '.js-filter-title', function () {
      var $legend = $(this);
      $legend.closest('.filter').toggleClass('is-active').find('.filter__options').slideToggle();
    });
  }

  // Document ready
  $(function () {
    initialize();
  });

  // Section update
  $(document).on('shopify:section:load', function () {
    initialize();
  });
})(window.jQuery);
(function () {
  var TableFilter = function () {
    function TableFilter(group) {
      _classCallCheck(this, TableFilter);

      this.group = group;
      this.inputs = document.querySelectorAll('[data-size-chart-navigation=' + this.group + '] input[type="radio"]');
      this.tables = Array.from(document.querySelectorAll('[data-size-table-container="' + this.group + '"]'));

      this.bindEvents();
    }

    _createClass(TableFilter, [{
      key: 'bindEvents',
      value: function bindEvents() {
        var _this38 = this;

        this.inputs.forEach(function (input) {
          return input.addEventListener('change', function (e) {
            return _this38.filterTable(e);
          });
        });
      }
    }, {
      key: 'filterTable',
      value: function filterTable(event) {
        var size_table = this.tables.filter(function (table) {
          table.classList.remove('is-open');
          return table.id == event.target.name + '-' + event.target.value;
        });

        size_table[0].classList.add('is-open');
      }
    }]);

    return TableFilter;
  }();

  function initializeTableFilter() {
    var size_section = document.getElementById('shopify-section-size-chart');
    if (size_section && !size_section.classList.contains('is-initialized')) {
      var table_containers = Array.from(document.querySelectorAll('[data-size-table-container]'));
      var all_groups = table_containers.map(function (container) {
        return container.dataset.sizeTableContainer;
      });
      var groups = [].concat(_toConsumableArray(new Set(all_groups)));
      var size_chart_button = [].concat(_toConsumableArray(document.querySelectorAll('.js-size-chart-modal')));
      groups.forEach(function (group) {
        new TableFilter(group);
      });

      size_chart_button.forEach(function (button) {
        button.addEventListener('click', function (e) {
          e.preventDefault();
          var size_chart_modal = new theme.Modal(button.dataset.modalTarget);
          size_chart_modal.show();
        });
      });
      size_section.classList.add('is-initialized');
    }
  }

  document.addEventListener('DOMContentLoaded', initializeTableFilter());
  document.addEventListener('shopify:section:load', initializeTableFilter());
})();
/**
 * WISHLIST LIBRARY
 *
 *	@description Handles calls from MODD's GiftReggie wishlist app
 *
 *	@namespace theme.wishList
 */
(function (theme, $, GiftReggie) {
  var WishList = function () {
    /**
     * Creates an instance of WishList.
     *
     * @constructs WishList
     */
    function WishList() {
      _classCallCheck(this, WishList);

      if (!GiftReggie) {
        return;
      }

      this.state = {
        ADD_BUTTON_CLASS: "wishlist-button--add",
        REMOVE_BUTTON_CLASS: "wishlist-button--remove"
      };

      this.session = null;
      this.id = null;
      this.selected_variants = [];
      this.$notification_container = $('[data-wishlist-notifications]');
      this.$wishlist_buttons = $('[data-wishlist-button]');

      // Loads if the page has the wishlist feature
      this.initializeSession();
    }

    /**
     * With the customer's credentials, it creates a session by making a call to the GiftReggie
     * app. It then retrieves the user's wish list from the app's server and caches it to the
     * Wishlist object
     *
     * @memberof Wishlist
     */


    _createClass(WishList, [{
      key: 'initializeSession',
      value: function initializeSession() {
        var _this39 = this;

        var customer = theme.customer || {
          id: '',
          email: '',
          gift_reggie: null
        };
        var gift_reggie_connection = null;

        // Uses GiftReggie's javascript object to make the connection to the app
        gift_reggie_connection = GiftReggie.getSession(customer.id, customer.email, customer.gift_reggie ? customer.gift_reggie.shared_secret : '');

        // Store the user's GiftReggie session and its functionalities
        gift_reggie_connection.then(function (session) {
          _this39.setSession(session);
          _this39.open(_this39);
        }).fail(function () {
          console.error('Could not connect to GiftReggie');
          _this39.bindListeners();
        });
      }
    }, {
      key: 'bindListeners',
      value: function bindListeners() {
        var _ = this;

        this.$wishlist_buttons.on('click', function (e) {
          e.preventDefault();
          var $this_button = $(this);
          var id = parseInt(_.selectedVariantId($this_button));

          if (!id) {
            _.errorMessage('Variant id could not be found.');
            return;
          }

          if (_.hasWishlist === false) {
            _.getSession().openWishlist();
          }

          if (!_.getSession() || _.getSession() && !_.getSession().customerEmail) {
            _.sendToWishListManager();
            return;
          }

          // Adds the product if it's not already in the wish list
          if (_.selected_variants.indexOf(id) == -1) {
            $.when(_.add(id)).then(function () {
              _.toggleButton(id, $this_button);
            });
          } else {
            $.when(_.remove(id)).then(function () {
              _.toggleButton(id, $this_button);
            });
          }
        });

        this.$wishlist_buttons.each(function () {
          var $button = $(this);
          _.toggleButton(parseInt(_.selectedVariantId($button)), $button);
        });

        $(document).on('VariantSelector:selectionUpdated', function (e, possible_variants) {
          var $button = $('.js-selector-variant').find('[data-wishlist-button]');
          _.toggleButton(parseInt(possible_variants[0].id), $button);
        });
      }

      /**
       * Returns the variant id that will be sent to wish list
       * @param {jQuery} $button - The selected wishlist button
       * @memberof Wishlist
       */

    }, {
      key: 'selectedVariantId',
      value: function selectedVariantId($button) {
        var $form_selector = $button.closest('.js-selector-variant').find('input[name="id"], select[name="id"]').get(0);
        if ($form_selector && $form_selector.value) {
          return $form_selector.value;
        } else {
          return $button.closest('.js-wishlist-tile').data('wishlist-default-variant-id');
        }
      }

      /**
       * Displays if the product is in the user's wishlist
       *
       * @param {integer} id - Selected product variant id
       * @param {jQuery} $wishlist_button - Contains the button who's state need to change
       * @memberof Wishlist
       *
       */

    }, {
      key: 'toggleButton',
      value: function toggleButton(id, $wishlist_button) {
        var is_in_wishlist = this.selected_variants.indexOf(id) > -1;
        $wishlist_button.toggleClass(this.state.REMOVE_BUTTON_CLASS, is_in_wishlist);
      }

      /**
       * Gets the session provided by GiftReggie's object class
       *
       * @memberof Wishlist
       */

    }, {
      key: 'getSession',
      value: function getSession() {
        return this.session;
      }

      /**
       * Sets the session provided by GiftReggie's object class
       *
       * @param {json} session - The Gift Reggie object that enables the user to make API call to their personal wishlist
       */

    }, {
      key: 'setSession',
      value: function setSession(session) {
        this.session = session;
      }

      /**
       * Adds the selected variant to the wish list on the
       * GiftReggie app and updates the cached wish list
       * on success
       *
       * @param {integer} id - Selected product variant id
       * @memberof Wishlist
       * @returns {boolean} Return true if the API call has been done succesfully
       */

    }, {
      key: 'add',
      value: function add(id) {
        var _this40 = this;

        return this.getSession().addWishlist(id).then(function (data) {
          _this40.selected_variants.push(id);
        });
      }

      /**
       * Removes the selected variant to the wish list on the
       * GiftReggie app and updates the cached wish list
       * on success
       *
       * @param {integer} id - Selected product variant id
       * @memberof Wishlist
       * @returns {boolean} Return true if the api call has been done succesfully
       */

    }, {
      key: 'remove',
      value: function remove(id) {
        var _this41 = this;

        return this.getSession().removeWishlist(id).then(function (data) {
          delete _this41.selected_variants[_this41.selected_variants.indexOf(id)];
        });
      }

      /**
       * Get the wish list from the GiftReggie app
       *
       * @memberof Wishlist
       * @returns {json}
       */

    }, {
      key: 'getRemoteWishlist',
      value: function getRemoteWishlist() {
        return this.getSession().getWishlist();
      }

      /**
       * Opens a wish list registry if one was not created and gets/creates remote wish list
       * for the user
       *
       * @memberof Wishlist
       * @returns
       */

    }, {
      key: 'open',
      value: function open() {
        var _this42 = this;

        this.hasWishlist = null;
        $.when($.ajax("/api/wishlist/open", {
          type: 'POST'
        })).always(function () {
          if (!_this42.getSession() || !_this42.getSession().customerEmail) {
            _this42.hasWishlist = false;
            _this42.bindListeners();
            return;
          } else {
            _this42.getRemoteWishlist().fail(function () {
              _this42.hasWishlist = false;
            }).then(function (data) {
              _this42.hasWishlist = true;
              var products = data.wishlist.products;

              // Caches the user's wish list
              for (var i = 0; i < products.length; ++i) {
                _this42.selected_variants.push(parseInt(products[i].variant_id));
              }
            }).always(function () {
              _this42.bindListeners();
            });
          }
        });
        return this.hasWishlist;
      }

      /**
       * Removes access to the user from having a wish list registry
       * @memberof Wishlist
       */

    }, {
      key: 'close',
      value: function close() {
        return this.getSession().closeWishlist();
      }

      /**
       * Outputs errors that are from the WishList object
       * @memberof Wishlist
       */

    }, {
      key: 'errorMessage',
      value: function errorMessage(error) {
        console.error('WishList: ' + error);
      }

      /**
       * Displays a notication when the limit of products added has been reached. (Usually 100)
       *
       * @param {json} data - Returns a response in case the max wishlist limit has been reached
       * @memberof Wishlist
       */

    }, {
      key: 'listLimitError',
      value: function listLimitError(data) {
        var error_title = '<h2>' + window.theme.shop + '</h2>';
        var error_message = '<p>' + data.responseJSON.error + ' Click <a href="/apps/giftregistry/wishlist?lang=' + window.theme.shop.locale + '">here</a> to manage it.</p>';

        this.$notification_container.find('.wishlist-notication__text').empty().append(error_title).append(error_message);

        this.$notification_container.show();
      }

      /**
       * Sends the user to their wish list registry. If the user is not logged in
       * they will be redirected to the login page
       *
       * @memberof Wishlist
       */

    }, {
      key: 'sendToWishListManager',
      value: function sendToWishListManager() {
        var sub_domain = window.theme.shop.locale.substring(0, 2);
        window.location.replace('/apps/giftregistry/wishlist?lang=' + sub_domain);
      }
    }]);

    return WishList;
  }();

  theme.Wishlist = new WishList();
})(window.theme = window.theme || {}, window.jQuery, window.GiftReggie);

/**
 * FAQ Page accordion
 *
 * Builds it out assuming that the questions are h2s and the content is between the questions
 */

(function (theme, $) {
  function initialize() {
    var $h2s = $('.js-faq-content h2');
    $h2s.each(function () {
      var $this = $(this);

      $this.addClass('js-accordion-trigger').attr('tabindex', '0');
      // grabs whatever elements come after each question, wrap them up
      $this.nextUntil('h2').wrapAll('<div class="accordion-item__content js-accordion-content"></div>');
      // grabs that div, the h2, and puts it in an a (& not a div, so that it is tab-able)
      $this.next().addBack().wrapAll('<div class="js-accordion-item accordion-item"></div>');
      // adds in the plus and minus guys
      $this.closest('.js-accordion-item').prepend('<span class="plus">' + theme.svgs.plus + '</span><span class="minus">' + theme.svgs.minus + '</span>');
    });

    $('.js-accordion-item').each(function () {
      new theme.AccordionItem(this);
    });
  }

  // Document ready
  $(function () {
    initialize();
  });

  // Section update
  $(document).on('shopify:section:load', function () {
    initialize();
  });
})(window.theme = window.theme || {}, jQuery);

(function ($, theme) {
  var KEY = 'AIzaSyDUowTmtbBdh2HxKHDNKpl-n4wpAxlKrDY';
  var cookie_name = 'geolocated';
  var cookie_domain = '.cosabella.com';
  var cookie_duration_in_days = 7;

  // North American country codes
  var NA_countries = ['AG', 'AI', 'AN', 'AW', 'BB', 'BM', 'BS', 'BZ', 'CA', 'CR', 'CU', 'DM', 'DO', 'GD', 'GL', 'GP', 'GT', 'HN', 'HT', 'JM', 'KN', 'KY', 'LC', 'MQ', 'MS', 'MX', 'NI', 'PA', 'PM', 'PR', 'SV', 'TC', 'TT', 'US', 'VC', 'VG', 'VI'];

  var Geolocator = function () {
    function Geolocator() {
      _classCallCheck(this, Geolocator);

      this.country;
      this.init();
    }

    _createClass(Geolocator, [{
      key: 'init',
      value: function init() {
        var _this43 = this;

        if (!Cookies.get(cookie_name)) {
          this.locate().then(function () {
            return _this43.geocode();
          }).then(function () {
            return _this43.loadPopup();
          });
        }
      }
    }, {
      key: 'locate',
      value: function locate() {
        var _this44 = this;

        return $.post('https://www.googleapis.com/geolocation/v1/geolocate?key=' + KEY).done(function (resp) {
          _this44.location = resp.location;
        }).fail(function (resp) {
          console.warn('Geolocator.locate: Failed to locate', resp);
        });
      }
    }, {
      key: 'geocode',
      value: function geocode(location) {
        var _this45 = this;

        location = location || this.location;

        if (!location || !location.lat || !location.lng) {
          console.error('Geolocator.geocode: Invalid location passed', location);
          return $.when();
        }

        return $.post('https://maps.googleapis.com/maps/api/geocode/json?latlng=' + location.lat + ',' + location.lng + '&key=' + KEY).done(function (resp) {
          var address = resp.results[0];

          if (Array.isArray(address.address_components)) {
            address.address_components.forEach(function (component) {
              if (~component.types.indexOf('country')) {
                _this45.country = component.short_name;
              }
            });
          }
        }).fail(function (resp) {
          console.warn('Geolocator.geocode: Failed to geocode', resp);
        });
      }
    }, {
      key: 'loadPopup',
      value: function loadPopup() {
        // Not on the right store, load the popup
        if (theme.shop.permanent_domain.indexOf('international') > 0 && NA_countries.indexOf(this.country) > 0 || // if on the international store but from NA
        theme.shop.permanent_domain.indexOf('north-america') > 0 && NA_countries.indexOf(this.country) < 0 // if on the NA store but from outside of NA
        ) {
            this.modal = new theme.Modal('geolocation');
            this.modal.show();

            /* $(this.modal.modal).on('Modal::hide', function () {
              // Geolocation has been seen
              Cookies.set(cookie_name, true);
            }); */
          }
          // Set a cookie to prevent excessive calls to the geolocation api
          Cookies.set(cookie_name, true, {
            domain: cookie_domain,
            expires: cookie_duration_in_days
          });
      }
    }]);

    return Geolocator;
  }();

  new Geolocator();
})(window.jQuery, window.theme = window.theme || {});
(function ($) {
  /**
   * Adds keyboard control to focusable labels.
   * - Simulates a click if the enter key is pressed.
   */
  $(document).on('keydown', 'div.select, .js-filter-title', function (e) {
    if (e.keyCode === 13 || e.keyCode === 32) {
      e.preventDefault();

      try {
        $(this).trigger('click');
      } catch (e) {}
    }
  });

  $(document).on('keydown', 'label[for]', function (e) {
    if (e.keyCode === 13 || e.keyCode === 32) {
      e.preventDefault();

      try {
        $('#' + $(this).attr('for')).trigger('click');
      } catch (e) {}
    }
  });
})(jQuery);

/*
  Just makes sure that all pages that don't have info banners have a border on their footer
*/
(function () {
  if ($('.js-info-banner ').length <= 1) {
    $('.footer').css('border-top', '0.8px solid black');
  }
})();

(function ($, theme) {
  function initialize() {
    var rendered_tiles = {};
    var item_to_edit, item_to_edit_qty;
    var edit_item_modal;

    function renderEditModal(html) {
      $('#edit-item-modal .js-modal-container').html(html);
    }

    function openEditModal(modal_id) {
      edit_item_modal = new theme.Modal(modal_id);

      edit_item_modal.show();
      $(edit_item_modal.modal).find('.modal__close').first().focus();
    }

    function initEditItemVariantSelector(product) {
      window.variantSelectorForms = window.variantSelectorForms || [];
      window.variantSelectorForms.push(new theme.VariantSelectorForm($('#edit-item-modal .js-product-container-edit'), product, true));
    }

    function initDropdowns() {
      document.querySelector('#edit-item-modal .js-modal-container').querySelectorAll('.js-dropdown-wrapper').forEach(function (wrapper) {
        new theme.RadioDropdown({
          wrapper: wrapper
        });
      });
    }

    $('.edit-product-qty').click(function (e) {
      e.preventDefault();

      var $this = $(this);
      var handle = $(this).data('product-handle');
      var modal_id = $(this).data('modal-target');

      function setupModal(html) {
        renderEditModal(html);
        initEditItemVariantSelector(theme.products._list[handle]);
        //initDropdowns();
        openEditModal(modal_id);
        item_to_edit = $this.data('key');
        item_to_edit_qty = $this.data('qty-edit');
  
      }

      if (rendered_tiles[handle]) {
        setupModal(rendered_tiles[handle]);
      } else {
        $.get('/products/' + handle + '?view=edit-item-ajax').then(function (html) {
          rendered_tiles[handle] = html;
          setupModal(html);
          
          $(".modal__close--edit").click(function() {
            $("#edit-item-modal").removeClass("modal--open");
            $("#edit-item-modal .product__images").removeClass("is-active");
            $("#edit-item-modal .modal__backdrop").fadeTo(500, 0.68);
            $("#edit-item-modal .modal__container").fadeIn(500);
            $("#edit-item-modal").trigger('Modal::hide');
          });

        });
      }
    });
  }

  $(function () {
    initialize();
    
    $(".js-cart-icon").click(function (e) {
      initialize();
    });
    
    $(document).on('AjaxCart:set', function () {
      initialize();
    });
    
  });
})(window.jQuery, window.theme);
(function ($, inView) {

  function initialize() {

    if (!document.querySelector('.js-scroll-fade')) {
      return;
    }

    inView.offset(200);

    inView('.js-scroll-fade').on('enter', function (el) {
      el.classList.add('is-loaded');
    });
  }

  // Document ready
  $(function () {
    initialize();
  });

  //  Additional events
  $(document).on('shopify:section:load', function () {
    initialize();
  });
})(jQuery, inView);

/* 
  Password Validator for Create Customer form

  Validates that value of the password field & the confirm password field matchbundleRenderer.renderToStream
  
  If they don't: 
  - disable the submit button 
  - add an aria-invalid to the confirm password field
  - display password warning under field
*/
(function () {

  if (document.getElementById('CreateCustomer')) {

    var createCustomerForm = document.getElementById('CreateCustomer');
    var passwordInput = createCustomerForm.querySelectorAll('[name="customer[password]"]')[0];
    var passwordConfirmInput = createCustomerForm.querySelectorAll('[name="customer[password_confirm]"]')[0];
    var submit = createCustomerForm.querySelectorAll('[type="submit"]')[0];

    var password = '';
    var passwordConfirm = '';

    var doPasswordsMatch = function doPasswordsMatch(p1, p2) {
      if (p1 == p2) {
        passwordConfirmInput.setAttribute('aria-invalid', false);
        submit.disabled = false;
      } else {
        passwordConfirmInput.setAttribute('aria-invalid', true);
        submit.disabled = true;
      }
    };

    passwordInput.addEventListener('blur', function (e) {
      password = e.target.value;
    });

    passwordConfirmInput.addEventListener('change', function (e) {
      passwordConfirm = e.target.value;
      if (password != passwordConfirm) {
        passwordConfirmInput.setAttribute('aria-invalid', true);
        submit.disabled = true;

        // input event listens to every change in the value. 
        // was having trouble getting the change event to retrigger once the pw matched
        passwordConfirmInput.addEventListener('input', function (e) {
          passwordConfirm = e.target.value;
          doPasswordsMatch(password, passwordConfirm);
        });

        passwordInput.addEventListener('input', function (e) {
          password = e.target.value;
          doPasswordsMatch(password, passwordConfirm);
        });
      }
    });
  }
})();
(function (theme) {
  var RadioDropdown = function () {
    function RadioDropdown(_ref16) {
      var wrapper = _ref16.wrapper;

      _classCallCheck(this, RadioDropdown);

      this.elements = {
        wrapper: wrapper,
        toggle: wrapper.querySelector('.js-dropdown-toggle'),
        label: wrapper.querySelector('.js-dropdown-label'),
        options_container: wrapper.querySelector('.js-dropdown-options-container'),
        options_radios: [].concat(_toConsumableArray(wrapper.querySelectorAll('.js-dropdown-option-radio'))),
        options_labels: [].concat(_toConsumableArray(wrapper.querySelectorAll('.js-dropdown-option-label')))
      };

      this.init();
    }

    _createClass(RadioDropdown, [{
      key: 'init',
      value: function init() {
        var _this46 = this;

        // init toggle event
        this.elements.toggle.addEventListener('click', function (e) {
          e.preventDefault();
          _this46._toggleDropdown();

          // to close the select by clicking outside of it
          var event_name = 'click.closeSelect--' + theme.utils.uniqueNumber();
          if (_this46.elements.toggle.classList.contains('is-open')) {
            $(document).on(event_name, function (e) {
              if ($(_this46.elements.wrapper).has(e.target).length === 0) {
                _this46._closeDropdown();
                $(document).off(event_name);
              }
            });
          } else {
            $(document).off(event_name);
          }
        });

        // init options event
        this.elements.options_radios.forEach(function (option, index) {
          return option.addEventListener('click', function () {
            //Use input value which is the country code instead of the full country name from the label/Use language code
            if (_this46.elements.options_container.classList.contains('js-country-selector')) {
              _this46.elements.label.innerText = _this46.elements.options_radios[index].getAttribute('data-country').toUpperCase();
            } else if (_this46.elements.options_container.classList.contains('js-language-picker')) {
              _this46.elements.label.innerText = _this46.elements.options_radios[index].value.split('-')[0].toUpperCase();
            } else {
              _this46.elements.label.innerText = _this46.elements.options_labels[index].innerText;
            }
            _this46._closeDropdown();
          });
        });

        // init keyboard key events
        [this.elements.toggle].concat(_toConsumableArray(this.elements.options_labels)).forEach(function (btn, index, array) {
          return btn.addEventListener('keydown', function (e) {
            if (!_this46.elements.toggle.classList.contains('is-open')) {
              return;
            }
            var i = index;
            switch (e.key) {
              case 'ArrowUp':
                // Focus to previous available element
                i--;
                while (i >= 0) {
                  if (array[i].getAttribute('tabindex') === '-1') {
                    i--;
                    continue;
                  }
                  e.preventDefault();
                  array[i].focus();
                  break;
                }
                break;

              case 'ArrowDown':
                // Focus to next available element
                i++;
                while (i < array.length) {
                  if (array[i].getAttribute('tabindex') === '-1') {
                    i++;
                    continue;
                  }
                  e.preventDefault();
                  array[i].focus();
                  break;
                }
                break;

              case 'Escape':
                // Close the select if you press the escape key
                e.preventDefault();
                _this46._closeDropdown();
                break;
              default:
                break;
            }
          });
        });
      }
    }, {
      key: '_openDropdown',
      value: function _openDropdown() {
        this.elements.toggle.classList.add('is-open');
        this.elements.toggle.setAttribute('aria-expanded', 'true');
        $(this.elements.options_container).slideDown();
      }
    }, {
      key: '_closeDropdown',
      value: function _closeDropdown() {
        this.elements.toggle.classList.remove('is-open');
        this.elements.toggle.setAttribute('aria-expanded', 'false');
        $(this.elements.options_container).slideUp();
      }
    }, {
      key: '_toggleDropdown',
      value: function _toggleDropdown() {
        this.elements.toggle.classList.contains('is-open') ? this._closeDropdown() : this._openDropdown();
      }
    }]);

    return RadioDropdown;
  }();

   document.querySelectorAll('.js-dropdown-wrapper').forEach(function (wrapper) {
    new RadioDropdown({
      wrapper: wrapper
    });
  }); 

  theme.RadioDropdown = RadioDropdown;
})(window.theme);